// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1.5L6 6.5L11 1.5%27 stroke=%27%236B7280%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1L5 5L9 1%27 stroke=%27%236B7280%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sticky header for Live Deals search/title bar */
.live-deals-sticky-header {
    position: sticky;
    top: 0;
    /* stick to below the app header if any margin needed, adjust if header height changes */
    z-index: 1030;
    /* above content but below navbars if they use higher z-index */
    /* background: #fff; */
    /* solid background to avoid transparency over content */
}

:root {
    --header-h: 0px;
    /* will be set dynamically */
}


body {
    font-family: var(--font-inter-regular);
    background-color: var(--color-bg);
}

html,
body {
    height: 100%;
}

main {
    height: 100vh;
    overflow-y: auto;
    /* scroll-snap-type: y mandatory; */
    /* scroll-behavior: smooth; */
    /* ensure snaps start below the fixed header */
    /* scroll-padding-top: var(--header-h); */
}

.cbp_layout {
    /* keep your padding */
    padding: 69px 0 15px 0;
    /* ensure padding is included in the fixed height */
    box-sizing: border-box;
    /* occupy full viewport height minus fixed header */
    /* min-height: calc(100vh - var(--header-h)); */
    /* enable snapping at the start of each section */
    /* scroll-snap-align: start; */
    /* scroll-snap-stop: always; */
}

.cbp_layout2 {
    padding: 100px 0 100px 0;
    box-sizing: border-box;
}

.cbp_layout3 {
    padding: 65px 0 25px 0;
    box-sizing: border-box;
}

.cbp_layout_header {
    /* scroll-snap-align: none; */
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999999;
    background-color: #fff;
}

/*---------- header styles --------*/

.brand-logo {
    width: 175px;
    padding: 5px 0px;
}

.grey-border-b-1 {
    border-bottom: 1px solid var(--color-grey);
}

/*---------- jumbotron styles --------*/


.slick-dots li button:before {
    color: white;
}

.slick-dots li.slick-active button:before {
    color: #007bff;
}

.slider-caption-1 h2 {
    font-family: var(--font-inter-semi-bold);
    font-size: var(--font-heading);
    font-weight: var(--font-bold);
    color: var(--text-color-white);
    padding: 10px 50px 0 50px;
}

.slider-caption-1 p {
    font-family: var(--font-inter-regular);
    font-size: var(--font-regular);
    color: var(--text-color-white);
    padding: 0 10px;
}

.carousel-slide-caption {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    padding: 20px;
}

.slider-caption-1 {
    inset: 0;
    background: rgba(0, 0, 0, 0.23);
    /* 23% black */
    backdrop-filter: blur(1.84px);
    /* blur the backdrop (background behind this element) */
    -webkit-backdrop-filter: blur(1.84px);
    /* Safari */
    z-index: 1;
}

.slider-caption-2 {
    padding: 5px 20px 20px 20px;
}

.slick-slide img {
    display: block;
    width: 100%;
}

.j-box {
    background-color: var(--color-white);
    padding: 15px 10px;
    border-radius: 0;
    box-shadow: 0px 1.07px 3.2px 0px rgba(0, 0, 0, 0.25);
    margin: 5px;
    flex: 0 0 auto;
    width: 33.33333333%;
}

.j-box h3 {
    font-family: var(--font-roboto-bold);
    font-size: var(--font-22);
    color: var(--text-color-secondary);
    margin-bottom: 2px;
}

.j-box p {
    font-family: var(--font-inter-regular);
    font-size: var(--font-large);
    color: var(--color-grey-2);
    margin-bottom: 0;
    line-height: 1.2;
}

/* fixed bottom two-button bar */
.cbp_fixed_menu {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: var(--color-white);
    border-top: 1px solid var(--color-grey);
    border-radius: 10px 10px 0 0;
}

.cbp_fixed_menu .col-12 {
    padding: 0;
}

.cbp_fixed_btn {
    display: inline-block;
    width: 50%;
    text-align: center;
    padding: 7px 9px;
    text-decoration: none;
    font-family: var(--font-inter-medium);
    color: var(--text-color-white);
    font-size: 13px;
}

.cbp_fixed_btn1 {
    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);
    border-radius: 10px 0 0 0;
}

.cbp_fixed_btn2 {
    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);
    border-radius: 0 10px 0 0;
}

.cbp_fixed_btn img {
    width: 26px;
    margin-bottom: 4px;
}

.h-fixed-70 .slick-list {
    height: 70vh;
}

/*---------- our team styles --------*/

.heading {
    font-family: var(--font-inter-semi-bold);
    font-size: var(--font-xxxlarge);
    color: var(--text-color-primary);
    margin-bottom: 3px;
}

.heading-md {
    font-family: var(--font-inter-semi-bold);
    font-size: var(--font-heading);
    color: var(--text-color-primary);
    margin-bottom: 3px;
}


.sub-desc {
    font-size: 13px;
    color: #1E86C0;
}

.team-card {
    box-shadow: 0px 0px 3.24px 0px rgba(0, 0, 0, 0.25);
    text-align: center;
    margin-bottom: 0px;
}

.profile-image img {
    width: 100%;
    object-fit: cover;
}

.team-info {
    padding: 10px 18px;
    min-height: 75px;
}

.team-card h3 {
    font-family: var(--font-inter-regular);
    font-size: var(--font-large);
    color: var(--text-color-primary);
    margin-bottom: 0;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.team-card h6 {
    font-family: var(--font-inter-regular);
    font-size: var(--font-rm);
    color: var(--text-color-primary);
    margin-bottom: 3px;
    margin-top: 3px;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.team-card p {
    font-family: var(--font-inter-medium);
    font-size: var(--font-small);
    color: var(--text-color-primary);
    margin-bottom: 0;
}

/*---------- asset classes styles --------*/

.class-card {
    border: 1px solid #E4982080;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 0px;
    padding: 15px 5px;
}

.class-image img {
    width: 43px;
}

.class-info {
    padding: 5px 15px;
    min-height: 91px;
}

.class-card h3 {
    font-family: var(--font-inter-semi-bold);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    margin-bottom: 5px;
    padding: 0 20px;
}

.class-card p {
    font-family: var(--font-inter-regular);
    font-size: var(--font-medium);
    color: var(--color-grey-3);
    margin-bottom: 0;
    line-height: 1.2;
}

/*---------- leads styles --------*/

.lead-card {
    /* box-shadow: 0px 0px 52.35px 0px rgba(0, 0, 0, 0.1); */
    /* box-shadow: 7.08px 7.08px 7.08px 0 rgba(0, 0, 0, 0.1); */
    /* box-shadow: 2.08px 3.08px 13.08px 0 rgba(0, 0, 0, 0.1); */
    /* border: 1px solid var(--btn-color-primary); */
    box-shadow: 2.08px 1.08px 9.08px 0 rgba(0, 0, 0, 0.1);
    border-radius: 14.17px;
    padding: 0px 0px;
    margin-bottom: 0px;
    background-color: var(--color-white);
}

.lead-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 9.73px 9.73px 0 0;
}

.lead-image {
    height: 240px !important;
}

.text-red {
    color: red;
}

.lead-title {
    font-family: var(--font-inter-semi-bold);
    color: var(--text-primary);
    margin-bottom: 5px;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* limit to 2 lines */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    text-transform: capitalize;
    font-size: var(--font-xxxlarge) !important;
}

.lead-detail h6 {
    font-family: var(--font-inter-semi-bold);
    color: var(--color-grey-3);
    margin-bottom: 2px;
    line-height: 1.2;
    text-transform: uppercase;
}

.lead-detail h2 {
    font-family: var(--font-inter-medium);
    font-size: var(--font-16);
    color: var(--color-subtitle);
    margin-bottom: 0;
    line-height: 1.2;
}

.lead-info {
    padding: 15px 20px 0px 20px;
    /* background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%); */
    border-radius: 0 0 14.17px 14.17px;
}


.lead-info-2 {
    padding: 15px 20px 15px 20px;
}

.lead-detail {
    margin-bottom: 15px;
}

.btn-primary {
    background-color: var(--btn-color-primary);
    border-radius: 50px;
    padding: 5px 14px;
    color: var(--text-color-white);
    font-family: var(--font-inter-medium);
    font-size: var(--font-medium);
}

.text-orange {
    color: var(--text-color-secondary) !important;
}

/*---------- progress bar styles ---------*/
.progress-bar-container {
    margin-bottom: 14px;
    margin-top: 10px;
}

.progress-bar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.progress-bar-label {
    font-family: var(--font-inter-regular);
    font-size: var(--font-11);
    color: var(--color-title);
    line-height: 1.2;
}

.progress-bar-percentage {
    font-family: var(--font-inter-regular);
    font-size: var(--font-11);
    color: var(--color-grey-3);
    line-height: 1.2;
}

.progress-bar {
    width: 100%;
    height: 7px;
    background-color: #EEEFF0;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
}

.progress-bar-fill {
    height: 100%;
    background-color: var(--text-color-secondary);
    border-radius: 6px;
    transition: width 0.3s ease-in-out;
    position: relative;
}

.progress-bar-fill::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 2px;
    height: 100%;
    background-color: var(--text-color-secondary);
}

/* Deal Card Specific Styles */
.lead-info-top {
    padding: 20px 30px 0 30px;
}

.lead-info-bottom {
    background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%);
    padding: 10px 20px 0px 20px;
    /* background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%); */
    border-radius: 0 0 14.17px 14.17px;
}

.badge-reserved-price {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary) !important;
    background-color: #DDE7F2 !important;
    height: 35px;
    display: flex;
    align-items: center;
}

.price-text {
    color: var(--bs-secondary-color) !important;
    font-weight: medium;
    font-family: var(--font-inter-medium);
    font-size: 13px;
}

.price-amount {
    color: #2B6CB0;
    font-weight: bold;
    font-family: var(--font-inter-bold);
    margin: 0;
    font-size: 21px;
}

.location-icon {
    width: 16px !important;
    height: auto !important;
    margin-right: 0px !important;
    margin-top: 1px !important;
    position: absolute !important;
    left: 10px !important;
}

.bg-gradient-linear {
    background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%);
}

/* @media (min-width: 1400px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 1440px;
    }
} */

.address-text {
    font-size: 12.5px;
    line-height: 1.3;
    /* color: var(--text-color-primary); */
    color: var(--bs-secondary-color) !important;
    padding-left: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}

.auction-text {
    font-size: 13.22px;
    letter-spacing: 0.5px;
}

.features-title {
    letter-spacing: 1px;
    font-size: 12px;
    color: #000000;
}

.features-box {
    background: #2B6CB0;
    color: white;
}

.feature-label {
    font-size: 7px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-weight: 400;
}

.feature-value {
    font-size: 14px;
}

.disclaimer-text {
    font-size: 10px;
    font-family: var(--font-inter-medium);
    color: #000000;
}

.btn-invest-now {
    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);
    border: 0;

}

/* arrows next to "Hot Deals" heading */
.heading-arrows {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    gap: 6px;
}

.heading-arrow-btn {
    width: 28px;
    height: 32px;
    line-height: 26px;
    text-align: center;
    border: 1px solid var(--color-grey);
    background: #fff;
    color: var(--text-color-primary);
    border-radius: 4px;
    padding: 0;
    font-family: var(--font-inter-semi-bold);
    cursor: pointer;
}

.heading-arrow-btn:hover {
    background: #f5f5f5;
}

.heading-arrow-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/*---------- cbp styles --------*/

.cbp-fixed-left ul,
.cbp-fixed-right ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.cbp-fixed-left ul li,
.cbp-fixed-right ul li {
    color: var(--btn-color-primary);
    font-family: var(--font-inter-semi-bold);
    font-size: var(--font-large);
    margin-bottom: 6px;
    border: 1px solid var(--border-color-primary);
    border-radius: 8px;
    padding: 0px 12px;
    box-shadow: 1.92px 0px 3.83px 0px rgba(0, 0, 0, 0.25);
    background-color: var(--color-white);
    display: flex;
    justify-content: left;
    align-items: center;
    min-height: 45px;
    white-space: nowrap;
    line-height: 1.2;
}

.fade-hidden {
    opacity: 0;
}

.cbp-fixed-left ul li:first-child,
.cbp-fixed-right ul li:first-child {
    background: radial-gradient(circle, #2EB2E7 -4%, #0F84B0 67%);
    color: var(--text-color-white);
}

.cbp-fixed-left ul li img,
.cbp-fixed-right ul li img {
    width: 24px;
    height: 24px;

}

/*---------- testimonials styles --------*/

.testimonial-card {
    border: 1px solid var(--color-green);
    border-radius: 48px;
    padding: 30px 20px;
    margin-bottom: 0px;
    background-color: var(--color-white);
    min-height: 398px;
    position: relative;
}

.testimonial-footer {
    position: absolute;
    bottom: 40px;
    left: 0;
    width: 100%;
    padding: 0 40px;
}

.testimonial-image img {
    width: 75px;
    height: 75px;
    object-fit: cover;
    border-radius: 100%;
    background-color: slategray;
}

.testimonial-info {
    padding: 13px 13px 0px 13px;
}

.testimonial-title {
    font-family: var(--font-inter-medium);
    color: var(--color-grey-4);
    font-size: var(--font-heading-2);
    margin-bottom: 0;
    line-height: 1.2;
    text-align: center;
}

.rating-stars {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px 0;
    gap: 1px;
}

.rating-stars .star {
    color: #F7941E;
    font-size: 20px;
    line-height: 1;
}

.testimonial-desc {
    font-family: var(--font-inter-regular);
    color: var(--text-color-gray);
    font-size: var(--font-xxlarge);
    margin-bottom: 15px;
    line-height: 1.2;
    margin-top: 15px;
}

.location-text span {
    font-family: var(--font-inter-regular);
    color: var(--color-grey-5);
    font-size: var(--font-large);
    margin-bottom: 0;
    line-height: 1.2;
    padding: 10px 20px;
    border-radius: 72px;
    background-color: var(--badge-primary);
}

.quote-icon {
    width: 38px !important;
}

/* Testimonials slider controls */
.tm-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    margin-top: 10px;
}

.tm-arrow {
    width: 30px;
    height: 30px;
    border: 2px solid var(--color-green);
    border-radius: 50%;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
    transition: background-color 150ms ease, opacity 150ms ease;
    opacity: 0.85;
}

.tm-arrow img {
    width: 14px;
    height: 14px;
}

.tm-arrow:hover {
    background: rgba(49, 139, 65, 0.08);
    /* subtle green tint */
    opacity: 1;
}

.tm-dots {
    display: inline-flex;
    align-items: center;
    gap: 12px;
}

.tm-dot {
    width: 22px;
    /* small pill width */
    height: 8px;
    border-radius: 999px;
    background: rgba(49, 139, 65, 0.25);
    /* muted green */
    border: 0;
    padding: 0;
    cursor: pointer;
    transition: width 200ms ease, background-color 200ms ease, opacity 150ms ease;
    opacity: 0.9;
}

.tm-dot.active {
    width: 70px;
    /* active is longer “progress” pill */
    background: var(--color-green);
    opacity: 1;
}

/*---------- footer styles --------*/

.footer-section {
    /* background-color: var(--btn-color-secondary); */
    background: linear-gradient(rgb(0, 130, 203) 0%, rgb(0, 78, 122) 100%);
}

.brand-logo-white {
    width: 100px;
    padding: 30px 10px 8px 10px;
}

.footer-heading {
    font-family: var(--font-monsterrat-semi-bold);
    font-size: var(--text-large);
    color: var(--text-color-white);
    line-height: 1.2;
    text-transform: uppercase;
}

.footer-heading-2 {
    font-family: var(--font-inter-regular);
    font-size: var(--font-xxlarge);
    color: var(--text-color-white);
    line-height: 1.2;
    letter-spacing: 0.2px;
    margin-bottom: 5px;
}

.footer-text {
    font-family: var(--font-inter-regular);
    font-size: var(--font-medium);
    color: var(--text-color-white);
    line-height: 1.2;
    opacity: 0.8;
    letter-spacing: 0.2px;
}

.lt-height {
    line-height: 1.5;
}

.social-links li {
    margin: 0 1px;
}

.social-links li a {
    text-decoration: none;
}

.tc-links li a {
    text-decoration: none;
    color: var(--text-color-white);
    font-family: var(--font-inter-regular);
    font-size: var(--font-large);
    letter-spacing: 0.2px;
    padding: 0px 8px;
}

.border-bottom-1 {
    border-bottom: 1px solid var(--text-color-white);
}

.footer-text-2 {
    font-family: var(--font-inter-regular);
    font-size: var(--font-large);
    color: var(--text-color-white);
    line-height: 1.4;
    letter-spacing: 0.2px;
}

.tc-links li:nth-child(1) a,
.tc-links li:nth-child(2) a {
    border-right: 1px solid var(--text-color-white);
}

/*---------- become member styles --------*/

.heading-lg {
    font-family: var(--font-inter-semi-bold);
    font-size: 26px;
    color: #090909;
    line-height: 1.2;
}

.become-member-form-container {
    padding: 20px;
}

.become-member-form {
    gap: 20px;
}

.form-group {
    margin-bottom: 15px;
}

.form-input {
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 16px;
    font-family: var(--font-inter-regular);
    background-color: #f9fafb;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    width: 100%;
    color: #000000;
}

.form-input::placeholder {
    font-size: var(--font-xlarge);
    font-family: var(--font-inter-regular);
    color: #6B6B6B;
}

.form-input:focus {
    outline: none;
    border-color: var(--btn-color-primary);
    box-shadow: 0 0 0 3px rgba(15, 132, 176, 0.1);
}

.form-input.error {
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.form-textarea {
    resize: vertical;
    min-height: 100px;
    font-family: var(--font-inter-regular);
}

.submit-button {
    background-color: var(--btn-color-primary);
    color: var(--text-color-white);
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-family: var(--font-inter-medium);
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;
    text-transform: none;
}

.submit-button:hover:not(:disabled) {
    background-color: var(--btn-color-secondary);
    transform: translateY(-1px);
}

.submit-button:active:not(:disabled) {
    transform: translateY(0);
}

.submit-button:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    transform: none;
}

.error-message {
    display: inline-block;
    background-color: rgba(220, 53, 69, 0.2);
    color: rgba(220, 53, 69, 1);
    font-size: 11px;
    margin-top: 6px;
    padding: 3px 8px;
    border-radius: 4px;
    font-family: var(--font-inter-medium);
    font-weight: 500;
}

.success-message {
    color: var(--color-green);
    font-size: 14px;
    margin-top: 8px;
    padding: 12px;
    background-color: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 8px;
    font-family: var(--font-inter-regular);
}

.form-group .form-input {
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    padding: 12px 16px;
    border: 1px solid #B4B4B4;
    border-radius: 8px;
    font-family: var(--font-inter-regular);
    background-color: #ffffff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    width: 100%;
}

select.form-input {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 16px center;
    background-size: 12px;
    padding-right: 40px;
}

.form-input:disabled,
.form-group .form-input:disabled {
    background-color: #E9ECEF;
    color: #6C757D;
    cursor: not-allowed;
    border-color: #D1D5DB;
}

/*---------- Membership Registration Stepper Form Styles --------*/

/* New Stepper Header - Box Style */
.stepper-header-new {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    gap: 15px;
}

.stepper-box {
    flex: 1 1;
    max-width: 450px;
    padding: 18px 24px;
    border-radius: 12px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.stepper-box.active {
    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);
}

.stepper-box.completed {
    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);
}

.stepper-box.inactive {
    background-color: #E8F4F8;
}

.stepper-box.inactive:hover {
    background-color: #D4ECF5;
}

.stepper-box-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.stepper-box-number {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-inter-semi-bold);
    font-size: 16px;
    flex-shrink: 0;
}

.stepper-box.active .stepper-box-number,
.stepper-box.completed .stepper-box-number {
    color: #004E7A;
}

.stepper-box.inactive .stepper-box-number {
    background-color: #FFFFFF;
    color: #64748B;
    border-color: #D1D5DB;
    border-width: 1.5px;
    border-style: solid;
}

.stepper-box .stepper-box-number {
    background-color: #FFFFFF;
    color: #004E7A;
    border-color: #D1D5DB;
    border-width: 1.5px;
    border-style: solid;
}

.stepper-box-label {
    font-family: var(--font-inter-medium);
    font-size: 15px;
    line-height: 1.4;
}

.stepper-box.active .stepper-box-label,
.stepper-box.completed .stepper-box-label {
    color: #FFFFFF;
}

.stepper-box.inactive .stepper-box-label {
    color: #64748B;
}

.stepper-arrow {
    font-size: 24px;
    color: #9CA3AF;
    flex-shrink: 0;
    padding: 0 5px;
}

.list-group .list-group-item {
    font-family: var(--font-inter-medium);
    font-size: var(--font-xlarge);
    /* color: rgba(33, 37, 41, 0.75); */
}

/* Form Container */
.membership-form-container {
    background-color: var(--color-white);
    padding: 37px 37px;
    border-radius: 8px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
}

/* Form Sections */
.form-section {
    margin-bottom: 30px;
}

.section-heading {
    font-family: var(--font-inter-semi-bold);
    font-size: 22px;
    color: var(--text-color-primary);
    margin-bottom: 10px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #E5E7EB; */
}

/* Form Labels */
.form-label {
    font-family: var(--font-inter-medium);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    margin-bottom: 6px;
    display: block;
}

/* Mobile Input Group */
.mobile-input-group {
    display: flex;
    gap: 8px;
}

.country-code-select {
    width: 100px;
    padding: 12px 28px 12px 12px;
    border: 1px solid #B4B4B4;
    border-radius: 4px;
    font-size: var(--font-xlarge);
    font-family: var(--font-inter-regular);
    background-color: #f9fafb;
    color: var(--text-color-primary);
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 10px;
}

.country-code-select:focus {
    outline: none;
    border-color: var(--btn-color-primary);
    box-shadow: 0 0 0 3px rgba(15, 132, 176, 0.1);
}

.mobile-input {
    flex: 1 1;
}

/* Input Validation Wrapper */
.input-with-validation {
    position: relative;
    flex: 1 1;
}

.validation-check {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #10B981;
    font-size: 20px;
    font-weight: bold;
    pointer-events: none;
    animation: checkmarkAppear 0.3s ease;
}

@keyframes checkmarkAppear {
    0% {
        opacity: 0;
        transform: translateY(-50%) scale(0.5);
    }

    100% {
        opacity: 1;
        transform: translateY(-50%) scale(1);
    }
}

.form-input.validated {
    border-color: #10B981;
}

/* Checkbox Group */
.checkbox-group {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.form-checkbox {
    width: 18px;
    height: 18px;
    margin-top: 2px;
    cursor: pointer;
    accent-color: var(--btn-color-primary);
    flex-shrink: 0;
}

.form-checkbox.error {
    outline: 2px solid #ef4444;
    outline-offset: 2px;
}

.checkbox-label {
    font-family: var(--font-inter-regular);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    line-height: 1.5;
    cursor: pointer;
    margin: 0;
}

/* Form Actions */
.form-actions {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    margin-top: 30px;
    border-top: 1px solid #E5E7EB;
}

.step2-actions {
    justify-content: space-between;
}

.btn-continue,
.btn-submit {
    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);
    color: var(--text-color-white);
    border: none;
    padding: 12px 32px;
    border-radius: 50px;
    font-size: var(--font-xlarge);
    font-family: var(--font-inter-semi-bold);
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075);
}

.btn-continue:hover,
.btn-submit:hover:not(:disabled) {
    background: linear-gradient(to bottom, #004E7A 0%, #0082CB 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(15, 132, 176, 0.4);
}

.btn-continue:active,
.btn-submit:active:not(:disabled) {
    transform: translateY(0);
}

.btn-submit:disabled {
    background: #9CA3AF;
    cursor: not-allowed;
    box-shadow: none;
}

.btn-back {
    background-color: transparent;
    color: var(--btn-color-primary);
    border: 2px solid var(--btn-color-primary);
    padding: 10px 32px;
    border-radius: 50px;
    font-size: var(--font-xlarge);
    font-family: var(--font-inter-semi-bold);
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-back:hover {
    background-color: var(--btn-color-primary);
    color: var(--text-color-white);
}

.card-text {
    font-size: var(--font-xlarge);
}

.declaration-box label {
    font-size: var(--font-xlarge) !important;
}

.msg-heading {
    font-size: 1.3rem;
    font-weight: 600;
}

/* Responsive Stepper */
@media (max-width: 768px) {
    .msg-heading {
        font-size: 1rem !important;
    }

    .heading-md {
        font-size: var(--font-xxxlarge);
    }

    .card-title {
        font-size: var(--font-xxlarge) !important;
    }

    .card-text {
        font-size: var(--font-medium) !important;
    }

    .stepper-header-new {
        flex-direction: column;
        gap: 12px;
    }

    .stepper-header-new {
        display: block;
    }

    .stepper-box {
        max-width: 100%;
        padding: 12px 14px;
        margin-bottom: 10px;
    }

    .stepper-box-label {
        font-size: 13px;
    }

    .form-section {
        margin-bottom: 12px;
    }

    .stepper-box-number {
        width: 28px;
        height: 28px;
        font-size: 14px;
    }

    .stepper-arrow {
        display: none;
    }

    .membership-form-container {
        padding: 5px;
    }

    .membership-form-container {
        background-color: var(--color-white)inherit;
        box-shadow: none;
    }

    .form-label {
        font-size: var(--font-large) !important;
    }

    .form-input,
    .form-input::placeholder {
        font-size: var(--font-large) !important;
    }

    .document-number,
    .checkbox-label {
        font-size: var(--font-large) !important;
    }

    .terms-content p {
        font-size: var(--font-large) !important;
    }

    .declaration-box label {
        font-size: var(--font-large) !important;
    }

    .form-checkbox {
        margin-top: 2px !important;
        width: 15px;
        height: 15px;
    }

    .section-heading {
        font-size: 16px;
        margin-bottom: 5px !important;
    }

    .declaration-box {
        background-color: #E0F2FE;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 15px;
    }

    .form-actions {
        flex-direction: column;
        gap: 12px;
        padding-top: 20px;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .step2-actions {
        flex-direction: column-reverse;
    }

    .btn-continue,
    .btn-submit,
    .btn-back {
        width: 100%;
    }

    .mobile-input-group {
        flex-direction: row;
    }

    .country-code-select {
        width: 80px;
    }
}

/* Back to Step Link */
.back-to-step {
    margin-bottom: 20px;
}

.back-link {
    background: none;
    border: none;
    color: var(--btn-color-primary);
    font-family: var(--font-inter-medium);
    font-size: var(--font-xlarge);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    transition: color 0.2s ease;
}

.back-link:hover {
    color: var(--btn-color-secondary);
}

.back-arrow {
    font-size: 18px;
    font-weight: bold;
}

/* Declaration Box */
.declaration-box {
    background-color: #E0F2FE;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
}

.declaration-list {
    list-style: disc;
    padding-left: 20px;
    margin: 0;
}

.declaration-list li {
    font-family: var(--font-inter-regular);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    line-height: 1.6;
    margin-bottom: 12px;
}

.declaration-list li:last-child {
    margin-bottom: 0;
}

/* Documents List */
.documents-list {
    margin-top: 10px;
}

.document-item {
    padding: 8px 0;
}

.document-number {
    font-family: var(--font-inter-regular);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
}

/* Utility Classes */
.mt-4 {
    margin-top: 20px;
}

/* Terms & Conditions Box */
.terms-conditions-box {
    background-color: var(--color-white);
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    padding: 0;
    margin-bottom: 20px;
    /* max-height: 500px; */
    /* overflow-y: auto; */
}

.terms-subheading {
    font-family: var(--font-inter-semi-bold);
    font-size: 16px;
    color: var(--text-color-primary);
    margin: 0;
    padding: 15px 20px;
    border-bottom: 1px solid #E5E7EB;
    background-color: #F9FAFB;
}

.terms-content {
    padding: 20px;
}

.terms-content p {
    font-family: var(--font-inter-regular);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    line-height: 1.6;
    margin-bottom: 15px;
    text-align: justify;
}

.document-item-wrapper .form-checkbox {
    margin-top: -5px !important;
}

.btn-sm {
    padding: 5px 5px !important;
}

.documents-list label {
    font-family: var(--font-inter-medium);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    margin-bottom: 6px;
    display: block;
}

.terms-content p:last-child {
    margin-bottom: 0;
}

.terms-content strong {
    font-family: var(--font-inter-semi-bold);
    /* color: var(--btn-color-primary); */
}

/* Custom scrollbar for terms box */
.terms-conditions-box::-webkit-scrollbar {
    width: 8px;
}

.terms-conditions-box::-webkit-scrollbar-track {
    background: #F3F4F6;
    border-radius: 4px;
}

.terms-conditions-box::-webkit-scrollbar-thumb {
    background: #D1D5DB;
    border-radius: 4px;
}

.terms-conditions-box::-webkit-scrollbar-thumb:hover {
    background: #9CA3AF;
}

/* Slider dots - simple light blue and active blue */
.slick-dots {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    display: flex !important;
    justify-content: center;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 8px;
}

.slick-dots li {
    margin: 0;
}

.slick-dots li button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: none;
    background: rgba(0, 130, 203, 0.5) !important;
    font-size: 0;
    cursor: pointer;
    transition: all 0.3s ease;
}

.slick-dots li button:before {
    display: none;
    /* Hide the default content */
}

/* Active dot - darker blue */
.slick-dots li.slick-active button {
    background: #004E7A !important;
    /* Darker blue for active dot */
    transform: scale(1.1);
}

.slick-dots li button:hover {
    background: #004E7A !important;
    /* Medium blue on hover */
    transform: scale(1.05);
}

.slick-dots li button {
    width: 15px !important;
    height: 15px !important;
    background: rgba(0, 130, 203, 0.5) !important;
}

.slick-dots li {
    margin: 0px !important;
    width: 12px !important;
    height: 12px !important;
}

.search-input {
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    padding: 5px 16px;
    border: 1px solid #B4B4B4;
    border-radius: 28px;
    font-family: var(--font-inter-regular);
    background-color: #ffffff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    width: 148px;
}

.live-deals-sticky-header {
    position: sticky;
    top: 0;
    z-index: 1030;
    /* background: #fff; */
}

.p-custom-grid {
    padding: 0px 12px;
}

.lead-card-2 {
    box-shadow: 0px 0px 23.85px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid #CFCFCF;
    border-radius: 4.73px;
    padding: 8px 8px;
    margin-bottom: 5px;
    background-color: var(--color-white);
}

.lead-2-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1.73px;
}

.recently-viewed-list ul li {
    font-family: var(--font-inter-regular);
    font-size: var(--font-large);
    color: #333333;
    line-height: 1.2;
    margin-bottom: 5px;
}

.recently-viewed-list ul li .btn-link {
    font-family: var(--font-inter-regular);
    font-size: var(--font-large);
    color: #333333;
    line-height: 1.2;
    margin-bottom: 5px;
}

.recently-viewed-list ul li img {
    width: 16px;
    height: 16px;
    position: relative;
    top: -1px;
}

.recently-viewed-list {
    border-top: 1px solid #BABABA;
    padding: 10px 0 0 0;
    margin-top: 3px;
}

/* .lead-2-image {
    height: 89px !important;
} */

.lead-2-image {
    height: 200px !important;
}

.lead-2-title {
    font-family: var(--font-inter-semi-bold);
    color: var(--color-title);
    margin-bottom: 0;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* limit to 2 lines */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}

.border-search-result {
    border: 1px solid #BABABA80;
    border-radius: 0 0 14px 14px;
    padding: 12px 15px;
}

.search-result-header h5 {
    font-family: var(--font-inter-regular);
    font-size: var(--font-large);
    color: #858585;
    line-height: 1.2;
    margin-bottom: 0;
}

.search-result-header h5 span {
    font-family: var(--font-inter-medium) !important;
    color: #464646 !important;
}

.search-result-header h5 span {
    font-family: var(--font-inter-medium);
    color: var(--text-color-secondary);
}

.search-result-header h5 span {
    font-family: var(--font-inter-medium);
    color: var(--text-color-secondary);
}

.alert {
    font-size: 12px !important;
    padding: 10px 15px;
    text-align: center;
    font-weight: 500;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .become-member-form-container {
        max-width: 100%;
        padding: 16px;
    }

    .form-input {
        font-size: var(--font-large) !important;
        /* Prevents zoom on iOS */
    }
}

/* Additional mobile-specific styles to match the image */
@media (max-width: 480px) {
    .become-member-form {
        gap: 16px;
    }

    .form-input {
        padding: 14px 16px;
    }

    .submit-button {
        padding: 14px 24px;
        font-size: 16px;
    }
}


@media screen and (min-width: 410px) and (max-width: 415px) {
    .mb-mob-3 {
        margin-bottom: 20px !important;
    }

    .mb-mob-33 {
        margin-bottom: 30px !important;
    }
}

@media (max-width: 480px) {
    .tm-controls {
        gap: 10px;
    }

    .tm-dot {
        width: 18px;
        height: 7px;
    }

    .tm-dot.active {
        width: 56px;
    }

    .tm-arrow {
        width: 28px;
        height: 28px;
    }

    .tm-arrow img {
        width: 12px;
        height: 12px;
    }
}

/* .slider-container div{
    padding: 50px;
    background-color: #0082CB;
} */
/*---------- responsive styles --------*/
@media (min-width: 768px) {
    .slider-caption-1 h2 {
        font-size: var(--text-large-2);
        padding: 40px 50px 3px 50px;
    }

    .slider-caption-1 p {
        font-size: var(--font-xxlarge);
        padding: 1px 0px 15px 0px;
    }

    .j-box h3 {
        font-size: var(--text-large-2);
    }

    .j-box p {
        font-size: var(--font-xxxlarge);
    }

    .slider-caption-2 {
        padding: 25px 10px 25px 10px;
        background-color: var(--color-white);
        border-radius: 12px;
        box-shadow: 0px 1.07px 3.2px 0px rgba(0, 0, 0, 0.25);
    }

    .dek-vertical-border {
        border-right: 2px solid #CCCCCC;
    }

    .j-box {
        padding: 5px 10px;
        box-shadow: none !important;
    }

    .brand-logo {
        width: 150px;
    }

    .cbp_layout {
        padding: 40px 0 15px 0;
    }

    .cbp_layout_member {
        padding: 90px 0 15px 0;
    }

    .cbp_layout-header {
        padding: 90px 0 15px 0;
    }

    .carousel-slide-caption {
        bottom: -90px;
    }

    .heading {
        font-size: var(--text-large);
    }

    .sub-desc {
        font-size: 20px;
    }

    .team-card h3 {
        font-size: var(--font-xxxlarge);
    }

    .team-card h6 {
        font-size: var(--font-large);
    }

    .team-card p {
        font-size: var(--font-medium);
    }

    .team-info {
        padding: 20px 25px;
        min-height: 120px;
    }

    .class-card h3 {
        font-size: var(--font-heading-3);
    }

    .class-card p {
        font-size: var(--font-16);
        min-height: 60px;
    }

    .class-image img {
        width: 72px;
    }

    .class-card {
        padding: 30px 30px;
        border-radius: 30px;
    }

    .class-card h3 {
        padding: 0 31px;
    }

    .class-card h3 {
        margin-bottom: 10px;
        margin-top: 10px;
        min-height: 22px;
    }


    .lead-card {
        margin: 5px 10px;
    }

    .heading-arrow-btn {
        width: 45px;
        height: 45px;
    }

    .heading-arrow-btn img {
        width: 20px;
        height: 20px;
    }

    .slick-card {
        background-color: inherit;
    }

    .heading-arrows {
        right: 96px;
    }

    .cbp-fixed-left ul li,
    .cbp-fixed-right ul li {
        min-height: 42px;
        margin-bottom: 8px;
        font-size: 16px;
    }

    .cbp-fixed-right {
        padding: 0 2px !important;
    }

    .testimonial-info {
        padding: 13px 32px 19px 32px;
    }

    .search-input {
        font-size: var(--font-xxlarge);
        padding: 12px 16px;
        width: 548px;
    }

    .search-result-header h5 {
        font-size: var(--font-xlarge);
    }

    .recently-viewed-list ul li .btn-link {
        font-size: var(--font-xlarge);
    }

    .navbar-brd {
        padding: 0px 5px 5px 31px !important;
    }

    .red-links {
        display: flex;
    }

    .red-links li a {
        background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);
        border-radius: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 8px 14px 8px 10px;
        text-decoration: none;
        font-family: var(--font-inter-medium);
        color: var(--text-color-white);
        font-size: 13px;
    }

    .red-links li a img {
        margin-right: 5px;
    }

    .red-links li {
        margin: 5px;
    }

    .cbp_fixed_menu {
        display: none;
    }

    .h-fixed-70 .slick-list {
        height: 75vh;
    }

    .slider-caption-1 {
        max-width: 615px;
        background: transparent !important;
    }

    .cbp-fixed-left ul li img,
    .cbp-fixed-right ul li img {
        width: 30px;
        height: 30px;
    }

    .border-top-1 {
        border-top: 1px solid var(--text-color-white);
    }

    .social-links li {
        margin: 0 4px;
    }

    .footer-heading-2 {
        font-size: 20px;
        margin-bottom: 13px;
    }

    /* .pl-65 {
        padding-left: 65px;
    } */

    .footer-text {
        font-size: 16px;
        line-height: 1.4;
    }

    .min-vh-50 {
        padding: 10px 10px 20px 10px;
    }

    .brand-logo-white {
        width: 128px;
        padding: 8px 10px 8px 10px;
    }

    .col-fixed-1 {
        width: 54%;
    }

    .col-fixed-2 {
        width: 20%;
    }

    .col-fixed-3 {
        width: 27%;
    }

    .social-links li a img {
        width: 48px;
    }

    .footer-text-2 {
        font-size: var(--font-xlarge);
    }

    .tc-links li a {
        font-size: var(--font-xlarge);
    }

    /*---------- in desktop make view same as mobile view --------*/
    /* #root {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .App {
        max-width: 576px;
        width: 100%;
        margin: 0 auto;
        position: relative;
    }

    main {
        position: relative;
    }

    .cbp_layout_header {
        position: fixed;
        max-width: 576px;
        left: 50%;
        transform: translateX(-50%);
        right: auto;
        width: 100%;
    }

    .cbp_fixed_menu {
        position: fixed;
        max-width: 576px;
        left: 50%;
        transform: translateX(-50%);
        right: auto;
        width: 100%;
    }

    .cbp_layout {
        padding: 80px 0 15px 0;
    } */

    /*---------- in desktop make view same as mobile view --------*/


    .area-value {
        font-size: var(--font-16) !important;
        min-height: 46px;
    }

    .profile-image img {
        height: 280px;
        object-fit: cover;
    }

    .lead-title {
        font-size: var(--font-16) !important;
        min-height: 42px;
    }

    .address-text {
        min-height: 21px;
    }

    .lead-2-title {
        font-size: var(--font-16) !important;
        line-height: 1.2;
    }

    .lead-detail h6 {
        font-size: var(--font-11);
    }

    .lead-image {
        height: 182px !important;
    }
}

.terms-content ul li {
    font-family: var(--font-inter-regular);
    font-size: var(--font-xlarge);
    color: var(--text-color-primary);
    line-height: 1.6;
    margin-bottom: 15px;
    text-align: justify;
}

@media (max-width: 767px) {
    .deal-message {
        font-size: 14px !important;
    }

    .cbp_layout_member {
        padding: 70px 0 15px 0;
    }

    .terms-content ul li {
        font-family: var(--font-inter-regular);
        font-size: var(--font-xlarge);
        color: var(--text-color-primary);
        line-height: 1.6;
        margin-bottom: 8px;
        text-align: justify;
    }

    .cbp_layout2 {
        padding: 69px 0 100px 0;
        box-sizing: border-box;
    }

    .cbp_layout3 {
        padding: 70px 0 38px 0;
        box-sizing: border-box;
    }

    .cbp_layout-header {
        padding: 30px 0 15px 0;
    }

    .cbp_layout {
        padding: 5px 0 25px 0;
    }

    .lead-image {
        height: 190px;
    }

    .carousel-slide-caption {
        bottom: -95px !important;
    }

    .lead-title {
        font-size: var(--font-xxxlarge) !important;
    }

    .lead-2-title {
        font-size: var(--font-xxlarge) !important;
        line-height: 1.2;
    }

    .lead-detail h6 {
        font-size: var(--font-rm-2) !important;
    }

    .lead-detail h2 {
        font-size: var(--font-xxlarge) !important;
    }

    .testimonial-card {
        padding: 74px 20px !important;
    }

    .footer-section {
        padding: 15px 0 120px 0 !important;
    }
}

@media (max-width: 414px) {
    .testimonial-card {
        padding: 74px 20px !important;
    }

    .cbp-fixed-left ul li,
    .cbp-fixed-right ul li {
        min-height: 40px !important;
    }

    .carousel-slide-caption {
        bottom: -82px !important;
    }

    .profile-image img {
        height: 170px !important;
    }

    .class-card {
        padding: 14px 5px !important;
    }

    .class-card h3 {
        font-size: var(--font-xlarge) !important;
    }

    .class-card p {
        font-size: var(--font-medium) !important;
    }

    .lead-title {
        font-size: var(--font-xxxlarge) !important;
    }

    .lead-2-title {
        font-size: var(--font-xxlarge) !important;
        line-height: 1.2;
    }

    .lead-detail h6 {
        font-size: var(--font-large) !important;
    }

    .lead-detail h2 {
        font-size: var(--font-xxxlarge) !important;
    }

    .lead-image {
        height: 190px !important;
    }
}

@media (max-width: 411px) {
    .testimonial-card {
        padding: 38px 20px !important;
    }

    .cbp-fixed-left ul li,
    .cbp-fixed-right ul li {
        min-height: 40px !important;
    }

    .carousel-slide-caption {
        bottom: -82px !important;
    }

    .profile-image img {
        height: 135px !important;
    }

    .class-card {
        padding: 11px 5px !important;
    }

    .class-card h3 {
        font-size: var(--font-large) !important;
    }

    .class-card p {
        font-size: var(--font-rm-2) !important;
    }

    .class-info {
        min-height: 70px !important;
    }

    .lead-title {
        font-size: var(--font-xxxlarge) !important;
    }

    .lead-2-title {
        font-size: var(--font-xxlarge) !important;
        line-height: 1.2;
    }

    .lead-detail h6 {
        font-size: var(--font-large) !important;
    }

    .lead-detail h2 {
        font-size: var(--font-xxxlarge) !important;
    }

    .lead-image {
        height: 190px !important;
    }
}

@media (max-width: 375px) {
    .testimonial-card {
        padding: 28px 20px !important;
    }

    .cbp-fixed-left ul li,
    .cbp-fixed-right ul li {
        min-height: 40px !important;
    }

    .lead-image {
        height: 190px;
    }

    .carousel-slide-caption {
        bottom: -82px !important;
    }

    .class-card {
        padding: 8px 5px !important;
    }

    .class-card h3 {
        font-size: 11px !important;
        margin-bottom: 3px;
        padding: 0 28px;
    }

    .class-card p {
        font-size: var(--font-rm-2) !important;
    }

    .class-info {
        padding: 5px 15px;
        min-height: 77px;
    }

    .class-image img {
        width: 38px;
    }

    .team-card h6 {
        margin-top: 3px !important;
    }

    .lead-title {
        font-size: var(--font-xxlarge) !important;
    }

    .lead-2-title {
        font-size: var(--font-xxlarge) !important;
        line-height: 1.2;
    }

    .lead-detail h6 {
        font-size: var(--font-11) !important;
    }

    .lead-detail h2 {
        font-size: var(--font-16) !important;
    }
}

@media (max-width: 360px) {
    .testimonial-card {
        padding: 28px 20px !important;
    }

    .cbp-fixed-left ul li,
    .cbp-fixed-right ul li {
        min-height: 38px !important;
    }

    .lead-image {
        height: 190px;
    }

    .carousel-slide-caption {
        bottom: -58px !important;
    }

    .team-card h6 {
        margin-top: 3px !important;
    }

    .profile-image img {
        height: 120px !important;
    }

    .class-card {
        padding: 8px 5px !important;
    }

    .class-card h3 {
        font-size: 11px !important;
        margin-bottom: 3px;
        padding: 0 28px;
    }

    .class-card p {
        font-size: var(--font-rm-2) !important;
    }

    .class-info {
        padding: 5px 15px;
        min-height: 75px;
    }

    .class-image img {
        width: 38px;
    }

    .lead-title {
        font-size: var(--font-xxlarge) !important;
    }

    .lead-2-title {
        font-size: var(--font-xxlarge) !important;
        line-height: 1.2;
    }

    .lead-detail h6 {
        font-size: var(--font-11) !important;
    }

    .lead-detail h2 {
        font-size: var(--font-xxlarge) !important;
    }

    .heading-lg {
        font-size: 17px !important;
    }

    .faq-question h3 {
        font-size: var(--font-xlarge) !important;
    }

    .faq-answer p {
        font-size: var(--font-medium) !important;
    }
}

/*---------- FAQ accordion styles --------*/

.faq-accordion {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;
}

.faq-item {
    border: 1px solid var(--btn-color-primary);
    border-radius: 12px;
    background-color: var(--color-white);
    overflow: hidden;
    transition: all 0.3s ease;
    box-shadow: none;

}

.deal-message {
    font-size: 17px;
    padding: 0 50px;
}

.deal-message span {
    font-weight: 500;
}

.sin-button {
    font-family: var(--font-inter-medium);
    color: var(--text-color-white);
    font-size: 13px;
}

.faq-item:hover {
    box-shadow: 0px 4px 12px rgba(15, 132, 176, 0.15);
}

.faq-item.active {
    border-color: var(--btn-color-primary);
    box-shadow: 0px 4px 12px rgba(15, 132, 176, 0.2);
}

.faq-question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 20px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: background-color 0.2s ease;
}

.faq-question:hover {
    background-color: rgba(15, 132, 176, 0.03);
}

.faq-question h3 {
    font-family: var(--font-inter-semi-bold);
    font-size: var(--font-xxxlarge);
    color: var(--text-color-primary);
    margin: 0;
    padding-right: 15px;
    line-height: 1.4;
    flex: 1 1;
}

.faq-icon {
    width: 32px;
    height: 32px;
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: rgba(15, 132, 176, 0.1);
    transition: all 0.3s ease;
}

.faq-icon svg {
    color: var(--btn-color-primary);
    transition: transform 0.3s ease;
}

.faq-icon.rotate svg {
    transform: rotate(180deg);
}

.faq-item.active .faq-icon {
    background-color: var(--btn-color-primary);
}

.faq-item.active .faq-icon svg {
    color: var(--text-color-white);
}

.faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease, padding 0.4s ease;
    padding: 0 20px;
}

.faq-answer.show {
    max-height: 500px;
    padding: 0 20px 18px 20px;
}

.faq-answer p {
    font-size: var(--font-xxlarge);
    color: var(--color-grey-3);
    font-family: var(--font-inter-regular);
    line-height: 1.4;
    margin-bottom: 5px;
}

.date-input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.calendar-icon-wrapper {
    position: absolute;
    right: 12px;
    /* Adjust if validation checkmark is present, maybe right: 35px if validated */
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 10;
}

.date-input-container.validated .calendar-icon-wrapper {
    right: 35px;
}

.calendar-icon {
    color: #6B7280;
    font-size: 16px;
}

.form-check-input {
    border-color: gray;
}

@media (min-width: 768px) and (max-width: 1440px) {
    .testimonial-card {
        min-height: 378px;
    }

    .testimonial-desc {
        font-size: var(--font-large);
    }

    .lead-title {
        font-size: var(--font-xlarge) !important;
    }

    .badge-reserved-price {
        font-size: 11px !important;
    }

    .price-text {
        font-size: 20px !important;
    }

    .auction-text {
        font-size: 11.22px !important;
    }

    .address-text {
        font-size: 10.22px;
    }

    .disclaimer-text {
        font-size: 8px;
    }

    .feature-label {
        font-size: 6px;
    }

}

.area-value {
    line-height: 1.4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;IACI,gBAAgB;IAChB,MAAM;IACN,wFAAwF;IACxF,aAAa;IACb,+DAA+D;IAC/D,sBAAsB;IACtB,wDAAwD;AAC5D;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;;AAGA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mCAAmC;IACnC,6BAA6B;IAC7B,8CAA8C;IAC9C,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mDAAmD;IACnD,sBAAsB;IACtB,mDAAmD;IACnD,+CAA+C;IAC/C,iDAAiD;IACjD,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,oCAAoC;;AAEpC;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,uCAAuC;;;AAGvC;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,+BAA+B;IAC/B,cAAc;IACd,6BAA6B;IAC7B,uDAAuD;IACvD,qCAAqC;IACrC,WAAW;IACX,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,8BAA8B;IAC9B,uCAAuC;IACvC,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qCAAqC;IACrC,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gEAAgE;IAChE,yBAAyB;AAC7B;;AAEA;IACI,gEAAgE;IAChE,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA,sCAAsC;;AAEtC;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,gCAAgC;IAChC,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,2CAA2C;;AAE3C;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,mCAAmC;;AAEnC;IACI,wDAAwD;IACxD,2DAA2D;IAC3D,4DAA4D;IAC5D,gDAAgD;IAChD,qDAAqD;IACrD,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,sEAAsE;IACtE,kCAAkC;AACtC;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;AACjD;;AAEA,2CAA2C;AAC3C;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,6CAA6C;IAC7C,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,6CAA6C;AACjD;;AAEA,8BAA8B;AAC9B;IACI,yBAAyB;AAC7B;;AAEA;IACI,gEAAgE;IAChE,2BAA2B;IAC3B,sEAAsE;IACtE,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mCAAmC;IACnC,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,gEAAgE;AACpE;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sCAAsC;IACtC,2CAA2C;IAC3C,kBAAkB;IAClB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,gEAAgE;IAChE,SAAS;;AAEb;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;IACV,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,iCAAiC;;AAEjC;;IAEI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,+BAA+B;IAC/B,wCAAwC;IACxC,4BAA4B;IAC5B,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;IAClB,iBAAiB;IACjB,qDAAqD;IACrD,oCAAoC;IACpC,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,6DAA6D;IAC7D,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,YAAY;;AAEhB;;AAEA,0CAA0C;;AAE1C;IACI,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,2DAA2D;IAC3D,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,oBAAoB;IACpB,mCAAmC;IACnC,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,eAAe;IACf,6EAA6E;IAC7E,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,8BAA8B;IAC9B,UAAU;AACd;;AAEA,oCAAoC;;AAEpC;IACI,kDAAkD;IAClD,sEAAsE;AAC1E;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,6CAA6C;IAC7C,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA,2CAA2C;;AAE3C;IACI,wCAAwC;IACxC,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,yBAAyB;IACzB,wDAAwD;IACxD,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;IAC1C,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,2DAA2D;IAC3D,oBAAoB;AACxB;;AAEA;IACI,4CAA4C;IAC5C,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;IACxC,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,yBAAyB;IACzB,wDAAwD;IACxD,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yDAA+Q;IAC/Q,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,kEAAkE;;AAElE,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA,mBAAmB;AACnB;IACI,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA,gBAAgB;AAChB;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,sCAAsC;IACtC,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,wDAAwD;IACxD,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yDAAwQ;IACxQ,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,6CAA6C;AACjD;;AAEA;IACI,SAAO;AACX;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,sCAAsC;IAC1C;;IAEA;QACI,UAAU;QACV,oCAAoC;IACxC;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,gEAAgE;IAChE,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,wCAAwC;IACxC,eAAe;IACf,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;;IAEI,gEAAgE;IAChE,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,wCAAwC;IACxC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,2CAA2C;QAC3C,gBAAgB;IACpB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;;QAEI,uCAAuC;IAC3C;;IAEA;;QAEI,uCAAuC;IAC3C;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,0BAA0B;QAC1B,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;;QAGI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,qCAAqC;IACrC,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA,mCAAmC;AACnC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA,6BAA6B;AAC7B;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;IACtC,yBAAyB;IACzB,wDAAwD;IACxD,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kDAAkD;IAClD,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,uCAAuC;QACvC,yBAAyB;IAC7B;AACJ;;AAEA,yDAAyD;AACzD;IACI;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;;;GAGG;AACH,wCAAwC;AACxC;IACI;QACI,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,4BAA4B;QAC5B,oCAAoC;QACpC,mBAAmB;QACnB,oDAAoD;IACxD;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;IACpB;;;IAGA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;QAC9B,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gEAAgE;QAChE,mBAAmB;QACnB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,0BAA0B;QAC1B,qBAAqB;QACrB,qCAAqC;QACrC,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kCAAkC;IACtC;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,6CAA6C;IACjD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;;OAEG;;IAEH;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA,+DAA+D;IAC/D;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OAqCG;;IAEH,+DAA+D;;;IAG/D;QACI,oCAAoC;QACpC,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,oCAAoC;QACpC,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oCAAoC;QACpC,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sCAAsC;QACtC,6BAA6B;QAC7B,gCAAgC;QAChC,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,yCAAyC;QACzC,gBAAgB;IACpB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,yCAAyC;QACzC,gBAAgB;IACpB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,yCAAyC;QACzC,gBAAgB;IACpB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,yCAAyC;QACzC,gBAAgB;IACpB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,yCAAyC;QACzC,gBAAgB;IACpB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;AACJ;;AAEA,2CAA2C;;AAE3C;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,sCAAsC;IACtC,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,gCAAgC;IAChC,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mDAAmD;IACnD,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,8EAA8E;IAC9E,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["/* Sticky header for Live Deals search/title bar */\n.live-deals-sticky-header {\n    position: sticky;\n    top: 0;\n    /* stick to below the app header if any margin needed, adjust if header height changes */\n    z-index: 1030;\n    /* above content but below navbars if they use higher z-index */\n    /* background: #fff; */\n    /* solid background to avoid transparency over content */\n}\n\n:root {\n    --header-h: 0px;\n    /* will be set dynamically */\n}\n\n\nbody {\n    font-family: var(--font-inter-regular);\n    background-color: var(--color-bg);\n}\n\nhtml,\nbody {\n    height: 100%;\n}\n\nmain {\n    height: 100vh;\n    overflow-y: auto;\n    /* scroll-snap-type: y mandatory; */\n    /* scroll-behavior: smooth; */\n    /* ensure snaps start below the fixed header */\n    /* scroll-padding-top: var(--header-h); */\n}\n\n.cbp_layout {\n    /* keep your padding */\n    padding: 69px 0 15px 0;\n    /* ensure padding is included in the fixed height */\n    box-sizing: border-box;\n    /* occupy full viewport height minus fixed header */\n    /* min-height: calc(100vh - var(--header-h)); */\n    /* enable snapping at the start of each section */\n    /* scroll-snap-align: start; */\n    /* scroll-snap-stop: always; */\n}\n\n.cbp_layout2 {\n    padding: 100px 0 100px 0;\n    box-sizing: border-box;\n}\n\n.cbp_layout3 {\n    padding: 65px 0 25px 0;\n    box-sizing: border-box;\n}\n\n.cbp_layout_header {\n    /* scroll-snap-align: none; */\n    position: fixed;\n    width: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 99999999;\n    background-color: #fff;\n}\n\n/*---------- header styles --------*/\n\n.brand-logo {\n    width: 175px;\n    padding: 5px 0px;\n}\n\n.grey-border-b-1 {\n    border-bottom: 1px solid var(--color-grey);\n}\n\n/*---------- jumbotron styles --------*/\n\n\n.slick-dots li button:before {\n    color: white;\n}\n\n.slick-dots li.slick-active button:before {\n    color: #007bff;\n}\n\n.slider-caption-1 h2 {\n    font-family: var(--font-inter-semi-bold);\n    font-size: var(--font-heading);\n    font-weight: var(--font-bold);\n    color: var(--text-color-white);\n    padding: 10px 50px 0 50px;\n}\n\n.slider-caption-1 p {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-regular);\n    color: var(--text-color-white);\n    padding: 0 10px;\n}\n\n.carousel-slide-caption {\n    position: absolute;\n    bottom: 30px;\n    left: 0;\n    right: 0;\n    padding: 20px;\n}\n\n.slider-caption-1 {\n    inset: 0;\n    background: rgba(0, 0, 0, 0.23);\n    /* 23% black */\n    backdrop-filter: blur(1.84px);\n    /* blur the backdrop (background behind this element) */\n    -webkit-backdrop-filter: blur(1.84px);\n    /* Safari */\n    z-index: 1;\n}\n\n.slider-caption-2 {\n    padding: 5px 20px 20px 20px;\n}\n\n.slick-slide img {\n    display: block;\n    width: 100%;\n}\n\n.j-box {\n    background-color: var(--color-white);\n    padding: 15px 10px;\n    border-radius: 0;\n    box-shadow: 0px 1.07px 3.2px 0px rgba(0, 0, 0, 0.25);\n    margin: 5px;\n    flex: 0 0 auto;\n    width: 33.33333333%;\n}\n\n.j-box h3 {\n    font-family: var(--font-roboto-bold);\n    font-size: var(--font-22);\n    color: var(--text-color-secondary);\n    margin-bottom: 2px;\n}\n\n.j-box p {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-large);\n    color: var(--color-grey-2);\n    margin-bottom: 0;\n    line-height: 1.2;\n}\n\n/* fixed bottom two-button bar */\n.cbp_fixed_menu {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background: var(--color-white);\n    border-top: 1px solid var(--color-grey);\n    border-radius: 10px 10px 0 0;\n}\n\n.cbp_fixed_menu .col-12 {\n    padding: 0;\n}\n\n.cbp_fixed_btn {\n    display: inline-block;\n    width: 50%;\n    text-align: center;\n    padding: 7px 9px;\n    text-decoration: none;\n    font-family: var(--font-inter-medium);\n    color: var(--text-color-white);\n    font-size: 13px;\n}\n\n.cbp_fixed_btn1 {\n    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);\n    border-radius: 10px 0 0 0;\n}\n\n.cbp_fixed_btn2 {\n    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);\n    border-radius: 0 10px 0 0;\n}\n\n.cbp_fixed_btn img {\n    width: 26px;\n    margin-bottom: 4px;\n}\n\n.h-fixed-70 .slick-list {\n    height: 70vh;\n}\n\n/*---------- our team styles --------*/\n\n.heading {\n    font-family: var(--font-inter-semi-bold);\n    font-size: var(--font-xxxlarge);\n    color: var(--text-color-primary);\n    margin-bottom: 3px;\n}\n\n.heading-md {\n    font-family: var(--font-inter-semi-bold);\n    font-size: var(--font-heading);\n    color: var(--text-color-primary);\n    margin-bottom: 3px;\n}\n\n\n.sub-desc {\n    font-size: 13px;\n    color: #1E86C0;\n}\n\n.team-card {\n    box-shadow: 0px 0px 3.24px 0px rgba(0, 0, 0, 0.25);\n    text-align: center;\n    margin-bottom: 0px;\n}\n\n.profile-image img {\n    width: 100%;\n    object-fit: cover;\n}\n\n.team-info {\n    padding: 10px 18px;\n    min-height: 75px;\n}\n\n.team-card h3 {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-large);\n    color: var(--text-color-primary);\n    margin-bottom: 0;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n.team-card h6 {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-rm);\n    color: var(--text-color-primary);\n    margin-bottom: 3px;\n    margin-top: 3px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n.team-card p {\n    font-family: var(--font-inter-medium);\n    font-size: var(--font-small);\n    color: var(--text-color-primary);\n    margin-bottom: 0;\n}\n\n/*---------- asset classes styles --------*/\n\n.class-card {\n    border: 1px solid #E4982080;\n    border-radius: 12px;\n    text-align: center;\n    margin-bottom: 0px;\n    padding: 15px 5px;\n}\n\n.class-image img {\n    width: 43px;\n}\n\n.class-info {\n    padding: 5px 15px;\n    min-height: 91px;\n}\n\n.class-card h3 {\n    font-family: var(--font-inter-semi-bold);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    margin-bottom: 5px;\n    padding: 0 20px;\n}\n\n.class-card p {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-medium);\n    color: var(--color-grey-3);\n    margin-bottom: 0;\n    line-height: 1.2;\n}\n\n/*---------- leads styles --------*/\n\n.lead-card {\n    /* box-shadow: 0px 0px 52.35px 0px rgba(0, 0, 0, 0.1); */\n    /* box-shadow: 7.08px 7.08px 7.08px 0 rgba(0, 0, 0, 0.1); */\n    /* box-shadow: 2.08px 3.08px 13.08px 0 rgba(0, 0, 0, 0.1); */\n    /* border: 1px solid var(--btn-color-primary); */\n    box-shadow: 2.08px 1.08px 9.08px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 14.17px;\n    padding: 0px 0px;\n    margin-bottom: 0px;\n    background-color: var(--color-white);\n}\n\n.lead-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 9.73px 9.73px 0 0;\n}\n\n.lead-image {\n    height: 240px !important;\n}\n\n.text-red {\n    color: red;\n}\n\n.lead-title {\n    font-family: var(--font-inter-semi-bold);\n    color: var(--text-primary);\n    margin-bottom: 5px;\n    line-height: 1.3;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    /* limit to 2 lines */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: normal;\n    text-transform: capitalize;\n    font-size: var(--font-xxxlarge) !important;\n}\n\n.lead-detail h6 {\n    font-family: var(--font-inter-semi-bold);\n    color: var(--color-grey-3);\n    margin-bottom: 2px;\n    line-height: 1.2;\n    text-transform: uppercase;\n}\n\n.lead-detail h2 {\n    font-family: var(--font-inter-medium);\n    font-size: var(--font-16);\n    color: var(--color-subtitle);\n    margin-bottom: 0;\n    line-height: 1.2;\n}\n\n.lead-info {\n    padding: 15px 20px 0px 20px;\n    /* background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%); */\n    border-radius: 0 0 14.17px 14.17px;\n}\n\n\n.lead-info-2 {\n    padding: 15px 20px 15px 20px;\n}\n\n.lead-detail {\n    margin-bottom: 15px;\n}\n\n.btn-primary {\n    background-color: var(--btn-color-primary);\n    border-radius: 50px;\n    padding: 5px 14px;\n    color: var(--text-color-white);\n    font-family: var(--font-inter-medium);\n    font-size: var(--font-medium);\n}\n\n.text-orange {\n    color: var(--text-color-secondary) !important;\n}\n\n/*---------- progress bar styles ---------*/\n.progress-bar-container {\n    margin-bottom: 14px;\n    margin-top: 10px;\n}\n\n.progress-bar-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.progress-bar-label {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-11);\n    color: var(--color-title);\n    line-height: 1.2;\n}\n\n.progress-bar-percentage {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-11);\n    color: var(--color-grey-3);\n    line-height: 1.2;\n}\n\n.progress-bar {\n    width: 100%;\n    height: 7px;\n    background-color: #EEEFF0;\n    border-radius: 6px;\n    overflow: hidden;\n    position: relative;\n}\n\n.progress-bar-fill {\n    height: 100%;\n    background-color: var(--text-color-secondary);\n    border-radius: 6px;\n    transition: width 0.3s ease-in-out;\n    position: relative;\n}\n\n.progress-bar-fill::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 2px;\n    height: 100%;\n    background-color: var(--text-color-secondary);\n}\n\n/* Deal Card Specific Styles */\n.lead-info-top {\n    padding: 20px 30px 0 30px;\n}\n\n.lead-info-bottom {\n    background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%);\n    padding: 10px 20px 0px 20px;\n    /* background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%); */\n    border-radius: 0 0 14.17px 14.17px;\n}\n\n.badge-reserved-price {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary) !important;\n    background-color: #DDE7F2 !important;\n    height: 35px;\n    display: flex;\n    align-items: center;\n}\n\n.price-text {\n    color: var(--bs-secondary-color) !important;\n    font-weight: medium;\n    font-family: var(--font-inter-medium);\n    font-size: 13px;\n}\n\n.price-amount {\n    color: #2B6CB0;\n    font-weight: bold;\n    font-family: var(--font-inter-bold);\n    margin: 0;\n    font-size: 21px;\n}\n\n.location-icon {\n    width: 16px !important;\n    height: auto !important;\n    margin-right: 0px !important;\n    margin-top: 1px !important;\n    position: absolute !important;\n    left: 10px !important;\n}\n\n.bg-gradient-linear {\n    background: linear-gradient(to bottom, #FFFFFF 0%, #CADAEB 100%);\n}\n\n/* @media (min-width: 1400px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 1440px;\n    }\n} */\n\n.address-text {\n    font-size: 12.5px;\n    line-height: 1.3;\n    /* color: var(--text-color-primary); */\n    color: var(--bs-secondary-color) !important;\n    padding-left: 20px;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: normal;\n}\n\n.auction-text {\n    font-size: 13.22px;\n    letter-spacing: 0.5px;\n}\n\n.features-title {\n    letter-spacing: 1px;\n    font-size: 12px;\n    color: #000000;\n}\n\n.features-box {\n    background: #2B6CB0;\n    color: white;\n}\n\n.feature-label {\n    font-size: 7px;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    font-weight: 400;\n}\n\n.feature-value {\n    font-size: 14px;\n}\n\n.disclaimer-text {\n    font-size: 10px;\n    font-family: var(--font-inter-medium);\n    color: #000000;\n}\n\n.btn-invest-now {\n    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);\n    border: 0;\n\n}\n\n/* arrows next to \"Hot Deals\" heading */\n.heading-arrows {\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: inline-flex;\n    gap: 6px;\n}\n\n.heading-arrow-btn {\n    width: 28px;\n    height: 32px;\n    line-height: 26px;\n    text-align: center;\n    border: 1px solid var(--color-grey);\n    background: #fff;\n    color: var(--text-color-primary);\n    border-radius: 4px;\n    padding: 0;\n    font-family: var(--font-inter-semi-bold);\n    cursor: pointer;\n}\n\n.heading-arrow-btn:hover {\n    background: #f5f5f5;\n}\n\n.heading-arrow-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/*---------- cbp styles --------*/\n\n.cbp-fixed-left ul,\n.cbp-fixed-right ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.cbp-fixed-left ul li,\n.cbp-fixed-right ul li {\n    color: var(--btn-color-primary);\n    font-family: var(--font-inter-semi-bold);\n    font-size: var(--font-large);\n    margin-bottom: 6px;\n    border: 1px solid var(--border-color-primary);\n    border-radius: 8px;\n    padding: 0px 12px;\n    box-shadow: 1.92px 0px 3.83px 0px rgba(0, 0, 0, 0.25);\n    background-color: var(--color-white);\n    display: flex;\n    justify-content: left;\n    align-items: center;\n    min-height: 45px;\n    white-space: nowrap;\n    line-height: 1.2;\n}\n\n.fade-hidden {\n    opacity: 0;\n}\n\n.cbp-fixed-left ul li:first-child,\n.cbp-fixed-right ul li:first-child {\n    background: radial-gradient(circle, #2EB2E7 -4%, #0F84B0 67%);\n    color: var(--text-color-white);\n}\n\n.cbp-fixed-left ul li img,\n.cbp-fixed-right ul li img {\n    width: 24px;\n    height: 24px;\n\n}\n\n/*---------- testimonials styles --------*/\n\n.testimonial-card {\n    border: 1px solid var(--color-green);\n    border-radius: 48px;\n    padding: 30px 20px;\n    margin-bottom: 0px;\n    background-color: var(--color-white);\n    min-height: 398px;\n    position: relative;\n}\n\n.testimonial-footer {\n    position: absolute;\n    bottom: 40px;\n    left: 0;\n    width: 100%;\n    padding: 0 40px;\n}\n\n.testimonial-image img {\n    width: 75px;\n    height: 75px;\n    object-fit: cover;\n    border-radius: 100%;\n    background-color: slategray;\n}\n\n.testimonial-info {\n    padding: 13px 13px 0px 13px;\n}\n\n.testimonial-title {\n    font-family: var(--font-inter-medium);\n    color: var(--color-grey-4);\n    font-size: var(--font-heading-2);\n    margin-bottom: 0;\n    line-height: 1.2;\n    text-align: center;\n}\n\n.rating-stars {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 5px 0;\n    gap: 1px;\n}\n\n.rating-stars .star {\n    color: #F7941E;\n    font-size: 20px;\n    line-height: 1;\n}\n\n.testimonial-desc {\n    font-family: var(--font-inter-regular);\n    color: var(--text-color-gray);\n    font-size: var(--font-xxlarge);\n    margin-bottom: 15px;\n    line-height: 1.2;\n    margin-top: 15px;\n}\n\n.location-text span {\n    font-family: var(--font-inter-regular);\n    color: var(--color-grey-5);\n    font-size: var(--font-large);\n    margin-bottom: 0;\n    line-height: 1.2;\n    padding: 10px 20px;\n    border-radius: 72px;\n    background-color: var(--badge-primary);\n}\n\n.quote-icon {\n    width: 38px !important;\n}\n\n/* Testimonials slider controls */\n.tm-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 14px;\n    margin-top: 10px;\n}\n\n.tm-arrow {\n    width: 30px;\n    height: 30px;\n    border: 2px solid var(--color-green);\n    border-radius: 50%;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    cursor: pointer;\n    transition: background-color 150ms ease, opacity 150ms ease;\n    opacity: 0.85;\n}\n\n.tm-arrow img {\n    width: 14px;\n    height: 14px;\n}\n\n.tm-arrow:hover {\n    background: rgba(49, 139, 65, 0.08);\n    /* subtle green tint */\n    opacity: 1;\n}\n\n.tm-dots {\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.tm-dot {\n    width: 22px;\n    /* small pill width */\n    height: 8px;\n    border-radius: 999px;\n    background: rgba(49, 139, 65, 0.25);\n    /* muted green */\n    border: 0;\n    padding: 0;\n    cursor: pointer;\n    transition: width 200ms ease, background-color 200ms ease, opacity 150ms ease;\n    opacity: 0.9;\n}\n\n.tm-dot.active {\n    width: 70px;\n    /* active is longer “progress” pill */\n    background: var(--color-green);\n    opacity: 1;\n}\n\n/*---------- footer styles --------*/\n\n.footer-section {\n    /* background-color: var(--btn-color-secondary); */\n    background: linear-gradient(rgb(0, 130, 203) 0%, rgb(0, 78, 122) 100%);\n}\n\n.brand-logo-white {\n    width: 100px;\n    padding: 30px 10px 8px 10px;\n}\n\n.footer-heading {\n    font-family: var(--font-monsterrat-semi-bold);\n    font-size: var(--text-large);\n    color: var(--text-color-white);\n    line-height: 1.2;\n    text-transform: uppercase;\n}\n\n.footer-heading-2 {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-xxlarge);\n    color: var(--text-color-white);\n    line-height: 1.2;\n    letter-spacing: 0.2px;\n    margin-bottom: 5px;\n}\n\n.footer-text {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-medium);\n    color: var(--text-color-white);\n    line-height: 1.2;\n    opacity: 0.8;\n    letter-spacing: 0.2px;\n}\n\n.lt-height {\n    line-height: 1.5;\n}\n\n.social-links li {\n    margin: 0 1px;\n}\n\n.social-links li a {\n    text-decoration: none;\n}\n\n.tc-links li a {\n    text-decoration: none;\n    color: var(--text-color-white);\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-large);\n    letter-spacing: 0.2px;\n    padding: 0px 8px;\n}\n\n.border-bottom-1 {\n    border-bottom: 1px solid var(--text-color-white);\n}\n\n.footer-text-2 {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-large);\n    color: var(--text-color-white);\n    line-height: 1.4;\n    letter-spacing: 0.2px;\n}\n\n.tc-links li:nth-child(1) a,\n.tc-links li:nth-child(2) a {\n    border-right: 1px solid var(--text-color-white);\n}\n\n/*---------- become member styles --------*/\n\n.heading-lg {\n    font-family: var(--font-inter-semi-bold);\n    font-size: 26px;\n    color: #090909;\n    line-height: 1.2;\n}\n\n.become-member-form-container {\n    padding: 20px;\n}\n\n.become-member-form {\n    gap: 20px;\n}\n\n.form-group {\n    margin-bottom: 15px;\n}\n\n.form-input {\n    padding: 12px 16px;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    font-size: 16px;\n    font-family: var(--font-inter-regular);\n    background-color: #f9fafb;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    width: 100%;\n    color: #000000;\n}\n\n.form-input::placeholder {\n    font-size: var(--font-xlarge);\n    font-family: var(--font-inter-regular);\n    color: #6B6B6B;\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: var(--btn-color-primary);\n    box-shadow: 0 0 0 3px rgba(15, 132, 176, 0.1);\n}\n\n.form-input.error {\n    border-color: #ef4444;\n    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.form-textarea {\n    resize: vertical;\n    min-height: 100px;\n    font-family: var(--font-inter-regular);\n}\n\n.submit-button {\n    background-color: var(--btn-color-primary);\n    color: var(--text-color-white);\n    border: none;\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-family: var(--font-inter-medium);\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease, transform 0.1s ease;\n    text-transform: none;\n}\n\n.submit-button:hover:not(:disabled) {\n    background-color: var(--btn-color-secondary);\n    transform: translateY(-1px);\n}\n\n.submit-button:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.submit-button:disabled {\n    background-color: #9ca3af;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.error-message {\n    display: inline-block;\n    background-color: rgba(220, 53, 69, 0.2);\n    color: rgba(220, 53, 69, 1);\n    font-size: 11px;\n    margin-top: 6px;\n    padding: 3px 8px;\n    border-radius: 4px;\n    font-family: var(--font-inter-medium);\n    font-weight: 500;\n}\n\n.success-message {\n    color: var(--color-green);\n    font-size: 14px;\n    margin-top: 8px;\n    padding: 12px;\n    background-color: #f0fdf4;\n    border: 1px solid #bbf7d0;\n    border-radius: 8px;\n    font-family: var(--font-inter-regular);\n}\n\n.form-group .form-input {\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    padding: 12px 16px;\n    border: 1px solid #B4B4B4;\n    border-radius: 8px;\n    font-family: var(--font-inter-regular);\n    background-color: #ffffff;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    width: 100%;\n}\n\nselect.form-input {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 16px center;\n    background-size: 12px;\n    padding-right: 40px;\n}\n\n.form-input:disabled,\n.form-group .form-input:disabled {\n    background-color: #E9ECEF;\n    color: #6C757D;\n    cursor: not-allowed;\n    border-color: #D1D5DB;\n}\n\n/*---------- Membership Registration Stepper Form Styles --------*/\n\n/* New Stepper Header - Box Style */\n.stepper-header-new {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 0;\n    gap: 15px;\n}\n\n.stepper-box {\n    flex: 1;\n    max-width: 450px;\n    padding: 18px 24px;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n.stepper-box.active {\n    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);\n}\n\n.stepper-box.completed {\n    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);\n}\n\n.stepper-box.inactive {\n    background-color: #E8F4F8;\n}\n\n.stepper-box.inactive:hover {\n    background-color: #D4ECF5;\n}\n\n.stepper-box-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.stepper-box-number {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.25);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: var(--font-inter-semi-bold);\n    font-size: 16px;\n    flex-shrink: 0;\n}\n\n.stepper-box.active .stepper-box-number,\n.stepper-box.completed .stepper-box-number {\n    color: #004E7A;\n}\n\n.stepper-box.inactive .stepper-box-number {\n    background-color: #FFFFFF;\n    color: #64748B;\n    border-color: #D1D5DB;\n    border-width: 1.5px;\n    border-style: solid;\n}\n\n.stepper-box .stepper-box-number {\n    background-color: #FFFFFF;\n    color: #004E7A;\n    border-color: #D1D5DB;\n    border-width: 1.5px;\n    border-style: solid;\n}\n\n.stepper-box-label {\n    font-family: var(--font-inter-medium);\n    font-size: 15px;\n    line-height: 1.4;\n}\n\n.stepper-box.active .stepper-box-label,\n.stepper-box.completed .stepper-box-label {\n    color: #FFFFFF;\n}\n\n.stepper-box.inactive .stepper-box-label {\n    color: #64748B;\n}\n\n.stepper-arrow {\n    font-size: 24px;\n    color: #9CA3AF;\n    flex-shrink: 0;\n    padding: 0 5px;\n}\n\n.list-group .list-group-item {\n    font-family: var(--font-inter-medium);\n    font-size: var(--font-xlarge);\n    /* color: rgba(33, 37, 41, 0.75); */\n}\n\n/* Form Container */\n.membership-form-container {\n    background-color: var(--color-white);\n    padding: 37px 37px;\n    border-radius: 8px;\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* Form Sections */\n.form-section {\n    margin-bottom: 30px;\n}\n\n.section-heading {\n    font-family: var(--font-inter-semi-bold);\n    font-size: 22px;\n    color: var(--text-color-primary);\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    /* border-bottom: 1px solid #E5E7EB; */\n}\n\n/* Form Labels */\n.form-label {\n    font-family: var(--font-inter-medium);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    margin-bottom: 6px;\n    display: block;\n}\n\n/* Mobile Input Group */\n.mobile-input-group {\n    display: flex;\n    gap: 8px;\n}\n\n.country-code-select {\n    width: 100px;\n    padding: 12px 28px 12px 12px;\n    border: 1px solid #B4B4B4;\n    border-radius: 4px;\n    font-size: var(--font-xlarge);\n    font-family: var(--font-inter-regular);\n    background-color: #f9fafb;\n    color: var(--text-color-primary);\n    cursor: pointer;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 15px center;\n    background-size: 10px;\n}\n\n.country-code-select:focus {\n    outline: none;\n    border-color: var(--btn-color-primary);\n    box-shadow: 0 0 0 3px rgba(15, 132, 176, 0.1);\n}\n\n.mobile-input {\n    flex: 1;\n}\n\n/* Input Validation Wrapper */\n.input-with-validation {\n    position: relative;\n    flex: 1;\n}\n\n.validation-check {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #10B981;\n    font-size: 20px;\n    font-weight: bold;\n    pointer-events: none;\n    animation: checkmarkAppear 0.3s ease;\n}\n\n@keyframes checkmarkAppear {\n    0% {\n        opacity: 0;\n        transform: translateY(-50%) scale(0.5);\n    }\n\n    100% {\n        opacity: 1;\n        transform: translateY(-50%) scale(1);\n    }\n}\n\n.form-input.validated {\n    border-color: #10B981;\n}\n\n/* Checkbox Group */\n.checkbox-group {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n}\n\n.form-checkbox {\n    width: 18px;\n    height: 18px;\n    margin-top: 2px;\n    cursor: pointer;\n    accent-color: var(--btn-color-primary);\n    flex-shrink: 0;\n}\n\n.form-checkbox.error {\n    outline: 2px solid #ef4444;\n    outline-offset: 2px;\n}\n\n.checkbox-label {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    line-height: 1.5;\n    cursor: pointer;\n    margin: 0;\n}\n\n/* Form Actions */\n.form-actions {\n    display: flex;\n    justify-content: center;\n    padding-top: 20px;\n    margin-top: 30px;\n    border-top: 1px solid #E5E7EB;\n}\n\n.step2-actions {\n    justify-content: space-between;\n}\n\n.btn-continue,\n.btn-submit {\n    background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);\n    color: var(--text-color-white);\n    border: none;\n    padding: 12px 32px;\n    border-radius: 50px;\n    font-size: var(--font-xlarge);\n    font-family: var(--font-inter-semi-bold);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075);\n}\n\n.btn-continue:hover,\n.btn-submit:hover:not(:disabled) {\n    background: linear-gradient(to bottom, #004E7A 0%, #0082CB 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(15, 132, 176, 0.4);\n}\n\n.btn-continue:active,\n.btn-submit:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.btn-submit:disabled {\n    background: #9CA3AF;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.btn-back {\n    background-color: transparent;\n    color: var(--btn-color-primary);\n    border: 2px solid var(--btn-color-primary);\n    padding: 10px 32px;\n    border-radius: 50px;\n    font-size: var(--font-xlarge);\n    font-family: var(--font-inter-semi-bold);\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.btn-back:hover {\n    background-color: var(--btn-color-primary);\n    color: var(--text-color-white);\n}\n\n.card-text {\n    font-size: var(--font-xlarge);\n}\n\n.declaration-box label {\n    font-size: var(--font-xlarge) !important;\n}\n\n.msg-heading {\n    font-size: 1.3rem;\n    font-weight: 600;\n}\n\n/* Responsive Stepper */\n@media (max-width: 768px) {\n    .msg-heading {\n        font-size: 1rem !important;\n    }\n\n    .heading-md {\n        font-size: var(--font-xxxlarge);\n    }\n\n    .card-title {\n        font-size: var(--font-xxlarge) !important;\n    }\n\n    .card-text {\n        font-size: var(--font-medium) !important;\n    }\n\n    .stepper-header-new {\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    .stepper-header-new {\n        display: block;\n    }\n\n    .stepper-box {\n        max-width: 100%;\n        padding: 12px 14px;\n        margin-bottom: 10px;\n    }\n\n    .stepper-box-label {\n        font-size: 13px;\n    }\n\n    .form-section {\n        margin-bottom: 12px;\n    }\n\n    .stepper-box-number {\n        width: 28px;\n        height: 28px;\n        font-size: 14px;\n    }\n\n    .stepper-arrow {\n        display: none;\n    }\n\n    .membership-form-container {\n        padding: 5px;\n    }\n\n    .membership-form-container {\n        background-color: var(--color-white)inherit;\n        box-shadow: none;\n    }\n\n    .form-label {\n        font-size: var(--font-large) !important;\n    }\n\n    .form-input,\n    .form-input::placeholder {\n        font-size: var(--font-large) !important;\n    }\n\n    .document-number,\n    .checkbox-label {\n        font-size: var(--font-large) !important;\n    }\n\n    .terms-content p {\n        font-size: var(--font-large) !important;\n    }\n\n    .declaration-box label {\n        font-size: var(--font-large) !important;\n    }\n\n    .form-checkbox {\n        margin-top: 2px !important;\n        width: 15px;\n        height: 15px;\n    }\n\n    .section-heading {\n        font-size: 16px;\n        margin-bottom: 5px !important;\n    }\n\n    .declaration-box {\n        background-color: #E0F2FE;\n        border-radius: 8px;\n        padding: 15px;\n        margin-bottom: 15px;\n    }\n\n    .form-actions {\n        flex-direction: column;\n        gap: 12px;\n        padding-top: 20px;\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n\n    .step2-actions {\n        flex-direction: column-reverse;\n    }\n\n    .btn-continue,\n    .btn-submit,\n    .btn-back {\n        width: 100%;\n    }\n\n    .mobile-input-group {\n        flex-direction: row;\n    }\n\n    .country-code-select {\n        width: 80px;\n    }\n}\n\n/* Back to Step Link */\n.back-to-step {\n    margin-bottom: 20px;\n}\n\n.back-link {\n    background: none;\n    border: none;\n    color: var(--btn-color-primary);\n    font-family: var(--font-inter-medium);\n    font-size: var(--font-xlarge);\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 0;\n    transition: color 0.2s ease;\n}\n\n.back-link:hover {\n    color: var(--btn-color-secondary);\n}\n\n.back-arrow {\n    font-size: 18px;\n    font-weight: bold;\n}\n\n/* Declaration Box */\n.declaration-box {\n    background-color: #E0F2FE;\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n\n.declaration-list {\n    list-style: disc;\n    padding-left: 20px;\n    margin: 0;\n}\n\n.declaration-list li {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    line-height: 1.6;\n    margin-bottom: 12px;\n}\n\n.declaration-list li:last-child {\n    margin-bottom: 0;\n}\n\n/* Documents List */\n.documents-list {\n    margin-top: 10px;\n}\n\n.document-item {\n    padding: 8px 0;\n}\n\n.document-number {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n}\n\n/* Utility Classes */\n.mt-4 {\n    margin-top: 20px;\n}\n\n/* Terms & Conditions Box */\n.terms-conditions-box {\n    background-color: var(--color-white);\n    border: 1px solid #D1D5DB;\n    border-radius: 8px;\n    padding: 0;\n    margin-bottom: 20px;\n    /* max-height: 500px; */\n    /* overflow-y: auto; */\n}\n\n.terms-subheading {\n    font-family: var(--font-inter-semi-bold);\n    font-size: 16px;\n    color: var(--text-color-primary);\n    margin: 0;\n    padding: 15px 20px;\n    border-bottom: 1px solid #E5E7EB;\n    background-color: #F9FAFB;\n}\n\n.terms-content {\n    padding: 20px;\n}\n\n.terms-content p {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    line-height: 1.6;\n    margin-bottom: 15px;\n    text-align: justify;\n}\n\n.document-item-wrapper .form-checkbox {\n    margin-top: -5px !important;\n}\n\n.btn-sm {\n    padding: 5px 5px !important;\n}\n\n.documents-list label {\n    font-family: var(--font-inter-medium);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    margin-bottom: 6px;\n    display: block;\n}\n\n.terms-content p:last-child {\n    margin-bottom: 0;\n}\n\n.terms-content strong {\n    font-family: var(--font-inter-semi-bold);\n    /* color: var(--btn-color-primary); */\n}\n\n/* Custom scrollbar for terms box */\n.terms-conditions-box::-webkit-scrollbar {\n    width: 8px;\n}\n\n.terms-conditions-box::-webkit-scrollbar-track {\n    background: #F3F4F6;\n    border-radius: 4px;\n}\n\n.terms-conditions-box::-webkit-scrollbar-thumb {\n    background: #D1D5DB;\n    border-radius: 4px;\n}\n\n.terms-conditions-box::-webkit-scrollbar-thumb:hover {\n    background: #9CA3AF;\n}\n\n/* Slider dots - simple light blue and active blue */\n.slick-dots {\n    position: absolute;\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 10;\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    gap: 8px;\n}\n\n.slick-dots li {\n    margin: 0;\n}\n\n.slick-dots li button {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    border: none;\n    background: rgba(0, 130, 203, 0.5) !important;\n    font-size: 0;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.slick-dots li button:before {\n    display: none;\n    /* Hide the default content */\n}\n\n/* Active dot - darker blue */\n.slick-dots li.slick-active button {\n    background: #004E7A !important;\n    /* Darker blue for active dot */\n    transform: scale(1.1);\n}\n\n.slick-dots li button:hover {\n    background: #004E7A !important;\n    /* Medium blue on hover */\n    transform: scale(1.05);\n}\n\n.slick-dots li button {\n    width: 15px !important;\n    height: 15px !important;\n    background: rgba(0, 130, 203, 0.5) !important;\n}\n\n.slick-dots li {\n    margin: 0px !important;\n    width: 12px !important;\n    height: 12px !important;\n}\n\n.search-input {\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    padding: 5px 16px;\n    border: 1px solid #B4B4B4;\n    border-radius: 28px;\n    font-family: var(--font-inter-regular);\n    background-color: #ffffff;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    width: 148px;\n}\n\n.live-deals-sticky-header {\n    position: sticky;\n    top: 0;\n    z-index: 1030;\n    /* background: #fff; */\n}\n\n.p-custom-grid {\n    padding: 0px 12px;\n}\n\n.lead-card-2 {\n    box-shadow: 0px 0px 23.85px 0px rgba(0, 0, 0, 0.1);\n    border: 1px solid #CFCFCF;\n    border-radius: 4.73px;\n    padding: 8px 8px;\n    margin-bottom: 5px;\n    background-color: var(--color-white);\n}\n\n.lead-2-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 1.73px;\n}\n\n.recently-viewed-list ul li {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-large);\n    color: #333333;\n    line-height: 1.2;\n    margin-bottom: 5px;\n}\n\n.recently-viewed-list ul li .btn-link {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-large);\n    color: #333333;\n    line-height: 1.2;\n    margin-bottom: 5px;\n}\n\n.recently-viewed-list ul li img {\n    width: 16px;\n    height: 16px;\n    position: relative;\n    top: -1px;\n}\n\n.recently-viewed-list {\n    border-top: 1px solid #BABABA;\n    padding: 10px 0 0 0;\n    margin-top: 3px;\n}\n\n/* .lead-2-image {\n    height: 89px !important;\n} */\n\n.lead-2-image {\n    height: 200px !important;\n}\n\n.lead-2-title {\n    font-family: var(--font-inter-semi-bold);\n    color: var(--color-title);\n    margin-bottom: 0;\n    line-height: 1.2;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    /* limit to 2 lines */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: normal;\n}\n\n.border-search-result {\n    border: 1px solid #BABABA80;\n    border-radius: 0 0 14px 14px;\n    padding: 12px 15px;\n}\n\n.search-result-header h5 {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-large);\n    color: #858585;\n    line-height: 1.2;\n    margin-bottom: 0;\n}\n\n.search-result-header h5 span {\n    font-family: var(--font-inter-medium) !important;\n    color: #464646 !important;\n}\n\n.search-result-header h5 span {\n    font-family: var(--font-inter-medium);\n    color: var(--text-color-secondary);\n}\n\n.search-result-header h5 span {\n    font-family: var(--font-inter-medium);\n    color: var(--text-color-secondary);\n}\n\n.alert {\n    font-size: 12px !important;\n    padding: 10px 15px;\n    text-align: center;\n    font-weight: 500;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n    .become-member-form-container {\n        max-width: 100%;\n        padding: 16px;\n    }\n\n    .form-input {\n        font-size: var(--font-large) !important;\n        /* Prevents zoom on iOS */\n    }\n}\n\n/* Additional mobile-specific styles to match the image */\n@media (max-width: 480px) {\n    .become-member-form {\n        gap: 16px;\n    }\n\n    .form-input {\n        padding: 14px 16px;\n    }\n\n    .submit-button {\n        padding: 14px 24px;\n        font-size: 16px;\n    }\n}\n\n\n@media screen and (min-width: 410px) and (max-width: 415px) {\n    .mb-mob-3 {\n        margin-bottom: 20px !important;\n    }\n\n    .mb-mob-33 {\n        margin-bottom: 30px !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .tm-controls {\n        gap: 10px;\n    }\n\n    .tm-dot {\n        width: 18px;\n        height: 7px;\n    }\n\n    .tm-dot.active {\n        width: 56px;\n    }\n\n    .tm-arrow {\n        width: 28px;\n        height: 28px;\n    }\n\n    .tm-arrow img {\n        width: 12px;\n        height: 12px;\n    }\n}\n\n/* .slider-container div{\n    padding: 50px;\n    background-color: #0082CB;\n} */\n/*---------- responsive styles --------*/\n@media (min-width: 768px) {\n    .slider-caption-1 h2 {\n        font-size: var(--text-large-2);\n        padding: 40px 50px 3px 50px;\n    }\n\n    .slider-caption-1 p {\n        font-size: var(--font-xxlarge);\n        padding: 1px 0px 15px 0px;\n    }\n\n    .j-box h3 {\n        font-size: var(--text-large-2);\n    }\n\n    .j-box p {\n        font-size: var(--font-xxxlarge);\n    }\n\n    .slider-caption-2 {\n        padding: 25px 10px 25px 10px;\n        background-color: var(--color-white);\n        border-radius: 12px;\n        box-shadow: 0px 1.07px 3.2px 0px rgba(0, 0, 0, 0.25);\n    }\n\n    .dek-vertical-border {\n        border-right: 2px solid #CCCCCC;\n    }\n\n    .j-box {\n        padding: 5px 10px;\n        box-shadow: none !important;\n    }\n\n    .brand-logo {\n        width: 150px;\n    }\n\n    .cbp_layout {\n        padding: 40px 0 15px 0;\n    }\n\n    .cbp_layout_member {\n        padding: 90px 0 15px 0;\n    }\n\n    .cbp_layout-header {\n        padding: 90px 0 15px 0;\n    }\n\n    .carousel-slide-caption {\n        bottom: -90px;\n    }\n\n    .heading {\n        font-size: var(--text-large);\n    }\n\n    .sub-desc {\n        font-size: 20px;\n    }\n\n    .team-card h3 {\n        font-size: var(--font-xxxlarge);\n    }\n\n    .team-card h6 {\n        font-size: var(--font-large);\n    }\n\n    .team-card p {\n        font-size: var(--font-medium);\n    }\n\n    .team-info {\n        padding: 20px 25px;\n        min-height: 120px;\n    }\n\n    .class-card h3 {\n        font-size: var(--font-heading-3);\n    }\n\n    .class-card p {\n        font-size: var(--font-16);\n        min-height: 60px;\n    }\n\n    .class-image img {\n        width: 72px;\n    }\n\n    .class-card {\n        padding: 30px 30px;\n        border-radius: 30px;\n    }\n\n    .class-card h3 {\n        padding: 0 31px;\n    }\n\n    .class-card h3 {\n        margin-bottom: 10px;\n        margin-top: 10px;\n        min-height: 22px;\n    }\n\n\n    .lead-card {\n        margin: 5px 10px;\n    }\n\n    .heading-arrow-btn {\n        width: 45px;\n        height: 45px;\n    }\n\n    .heading-arrow-btn img {\n        width: 20px;\n        height: 20px;\n    }\n\n    .slick-card {\n        background-color: inherit;\n    }\n\n    .heading-arrows {\n        right: 96px;\n    }\n\n    .cbp-fixed-left ul li,\n    .cbp-fixed-right ul li {\n        min-height: 42px;\n        margin-bottom: 8px;\n        font-size: 16px;\n    }\n\n    .cbp-fixed-right {\n        padding: 0 2px !important;\n    }\n\n    .testimonial-info {\n        padding: 13px 32px 19px 32px;\n    }\n\n    .search-input {\n        font-size: var(--font-xxlarge);\n        padding: 12px 16px;\n        width: 548px;\n    }\n\n    .search-result-header h5 {\n        font-size: var(--font-xlarge);\n    }\n\n    .recently-viewed-list ul li .btn-link {\n        font-size: var(--font-xlarge);\n    }\n\n    .navbar-brd {\n        padding: 0px 5px 5px 31px !important;\n    }\n\n    .red-links {\n        display: flex;\n    }\n\n    .red-links li a {\n        background: linear-gradient(to bottom, #0082CB 0%, #004E7A 100%);\n        border-radius: 48px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-align: center;\n        padding: 8px 14px 8px 10px;\n        text-decoration: none;\n        font-family: var(--font-inter-medium);\n        color: var(--text-color-white);\n        font-size: 13px;\n    }\n\n    .red-links li a img {\n        margin-right: 5px;\n    }\n\n    .red-links li {\n        margin: 5px;\n    }\n\n    .cbp_fixed_menu {\n        display: none;\n    }\n\n    .h-fixed-70 .slick-list {\n        height: 75vh;\n    }\n\n    .slider-caption-1 {\n        max-width: 615px;\n        background: transparent !important;\n    }\n\n    .cbp-fixed-left ul li img,\n    .cbp-fixed-right ul li img {\n        width: 30px;\n        height: 30px;\n    }\n\n    .border-top-1 {\n        border-top: 1px solid var(--text-color-white);\n    }\n\n    .social-links li {\n        margin: 0 4px;\n    }\n\n    .footer-heading-2 {\n        font-size: 20px;\n        margin-bottom: 13px;\n    }\n\n    /* .pl-65 {\n        padding-left: 65px;\n    } */\n\n    .footer-text {\n        font-size: 16px;\n        line-height: 1.4;\n    }\n\n    .min-vh-50 {\n        padding: 10px 10px 20px 10px;\n    }\n\n    .brand-logo-white {\n        width: 128px;\n        padding: 8px 10px 8px 10px;\n    }\n\n    .col-fixed-1 {\n        width: 54%;\n    }\n\n    .col-fixed-2 {\n        width: 20%;\n    }\n\n    .col-fixed-3 {\n        width: 27%;\n    }\n\n    .social-links li a img {\n        width: 48px;\n    }\n\n    .footer-text-2 {\n        font-size: var(--font-xlarge);\n    }\n\n    .tc-links li a {\n        font-size: var(--font-xlarge);\n    }\n\n    /*---------- in desktop make view same as mobile view --------*/\n    /* #root {\n        display: flex;\n        justify-content: center;\n        width: 100%;\n    }\n\n    .App {\n        max-width: 576px;\n        width: 100%;\n        margin: 0 auto;\n        position: relative;\n    }\n\n    main {\n        position: relative;\n    }\n\n    .cbp_layout_header {\n        position: fixed;\n        max-width: 576px;\n        left: 50%;\n        transform: translateX(-50%);\n        right: auto;\n        width: 100%;\n    }\n\n    .cbp_fixed_menu {\n        position: fixed;\n        max-width: 576px;\n        left: 50%;\n        transform: translateX(-50%);\n        right: auto;\n        width: 100%;\n    }\n\n    .cbp_layout {\n        padding: 80px 0 15px 0;\n    } */\n\n    /*---------- in desktop make view same as mobile view --------*/\n\n\n    .area-value {\n        font-size: var(--font-16) !important;\n        min-height: 46px;\n    }\n\n    .profile-image img {\n        height: 280px;\n        object-fit: cover;\n    }\n\n    .lead-title {\n        font-size: var(--font-16) !important;\n        min-height: 42px;\n    }\n\n    .address-text {\n        min-height: 21px;\n    }\n\n    .lead-2-title {\n        font-size: var(--font-16) !important;\n        line-height: 1.2;\n    }\n\n    .lead-detail h6 {\n        font-size: var(--font-11);\n    }\n\n    .lead-image {\n        height: 182px !important;\n    }\n}\n\n.terms-content ul li {\n    font-family: var(--font-inter-regular);\n    font-size: var(--font-xlarge);\n    color: var(--text-color-primary);\n    line-height: 1.6;\n    margin-bottom: 15px;\n    text-align: justify;\n}\n\n@media (max-width: 767px) {\n    .deal-message {\n        font-size: 14px !important;\n    }\n\n    .cbp_layout_member {\n        padding: 70px 0 15px 0;\n    }\n\n    .terms-content ul li {\n        font-family: var(--font-inter-regular);\n        font-size: var(--font-xlarge);\n        color: var(--text-color-primary);\n        line-height: 1.6;\n        margin-bottom: 8px;\n        text-align: justify;\n    }\n\n    .cbp_layout2 {\n        padding: 69px 0 100px 0;\n        box-sizing: border-box;\n    }\n\n    .cbp_layout3 {\n        padding: 70px 0 38px 0;\n        box-sizing: border-box;\n    }\n\n    .cbp_layout-header {\n        padding: 30px 0 15px 0;\n    }\n\n    .cbp_layout {\n        padding: 5px 0 25px 0;\n    }\n\n    .lead-image {\n        height: 190px;\n    }\n\n    .carousel-slide-caption {\n        bottom: -95px !important;\n    }\n\n    .lead-title {\n        font-size: var(--font-xxxlarge) !important;\n    }\n\n    .lead-2-title {\n        font-size: var(--font-xxlarge) !important;\n        line-height: 1.2;\n    }\n\n    .lead-detail h6 {\n        font-size: var(--font-rm-2) !important;\n    }\n\n    .lead-detail h2 {\n        font-size: var(--font-xxlarge) !important;\n    }\n\n    .testimonial-card {\n        padding: 74px 20px !important;\n    }\n\n    .footer-section {\n        padding: 15px 0 120px 0 !important;\n    }\n}\n\n@media (max-width: 414px) {\n    .testimonial-card {\n        padding: 74px 20px !important;\n    }\n\n    .cbp-fixed-left ul li,\n    .cbp-fixed-right ul li {\n        min-height: 40px !important;\n    }\n\n    .carousel-slide-caption {\n        bottom: -82px !important;\n    }\n\n    .profile-image img {\n        height: 170px !important;\n    }\n\n    .class-card {\n        padding: 14px 5px !important;\n    }\n\n    .class-card h3 {\n        font-size: var(--font-xlarge) !important;\n    }\n\n    .class-card p {\n        font-size: var(--font-medium) !important;\n    }\n\n    .lead-title {\n        font-size: var(--font-xxxlarge) !important;\n    }\n\n    .lead-2-title {\n        font-size: var(--font-xxlarge) !important;\n        line-height: 1.2;\n    }\n\n    .lead-detail h6 {\n        font-size: var(--font-large) !important;\n    }\n\n    .lead-detail h2 {\n        font-size: var(--font-xxxlarge) !important;\n    }\n\n    .lead-image {\n        height: 190px !important;\n    }\n}\n\n@media (max-width: 411px) {\n    .testimonial-card {\n        padding: 38px 20px !important;\n    }\n\n    .cbp-fixed-left ul li,\n    .cbp-fixed-right ul li {\n        min-height: 40px !important;\n    }\n\n    .carousel-slide-caption {\n        bottom: -82px !important;\n    }\n\n    .profile-image img {\n        height: 135px !important;\n    }\n\n    .class-card {\n        padding: 11px 5px !important;\n    }\n\n    .class-card h3 {\n        font-size: var(--font-large) !important;\n    }\n\n    .class-card p {\n        font-size: var(--font-rm-2) !important;\n    }\n\n    .class-info {\n        min-height: 70px !important;\n    }\n\n    .lead-title {\n        font-size: var(--font-xxxlarge) !important;\n    }\n\n    .lead-2-title {\n        font-size: var(--font-xxlarge) !important;\n        line-height: 1.2;\n    }\n\n    .lead-detail h6 {\n        font-size: var(--font-large) !important;\n    }\n\n    .lead-detail h2 {\n        font-size: var(--font-xxxlarge) !important;\n    }\n\n    .lead-image {\n        height: 190px !important;\n    }\n}\n\n@media (max-width: 375px) {\n    .testimonial-card {\n        padding: 28px 20px !important;\n    }\n\n    .cbp-fixed-left ul li,\n    .cbp-fixed-right ul li {\n        min-height: 40px !important;\n    }\n\n    .lead-image {\n        height: 190px;\n    }\n\n    .carousel-slide-caption {\n        bottom: -82px !important;\n    }\n\n    .class-card {\n        padding: 8px 5px !important;\n    }\n\n    .class-card h3 {\n        font-size: 11px !important;\n        margin-bottom: 3px;\n        padding: 0 28px;\n    }\n\n    .class-card p {\n        font-size: var(--font-rm-2) !important;\n    }\n\n    .class-info {\n        padding: 5px 15px;\n        min-height: 77px;\n    }\n\n    .class-image img {\n        width: 38px;\n    }\n\n    .team-card h6 {\n        margin-top: 3px !important;\n    }\n\n    .lead-title {\n        font-size: var(--font-xxlarge) !important;\n    }\n\n    .lead-2-title {\n        font-size: var(--font-xxlarge) !important;\n        line-height: 1.2;\n    }\n\n    .lead-detail h6 {\n        font-size: var(--font-11) !important;\n    }\n\n    .lead-detail h2 {\n        font-size: var(--font-16) !important;\n    }\n}\n\n@media (max-width: 360px) {\n    .testimonial-card {\n        padding: 28px 20px !important;\n    }\n\n    .cbp-fixed-left ul li,\n    .cbp-fixed-right ul li {\n        min-height: 38px !important;\n    }\n\n    .lead-image {\n        height: 190px;\n    }\n\n    .carousel-slide-caption {\n        bottom: -58px !important;\n    }\n\n    .team-card h6 {\n        margin-top: 3px !important;\n    }\n\n    .profile-image img {\n        height: 120px !important;\n    }\n\n    .class-card {\n        padding: 8px 5px !important;\n    }\n\n    .class-card h3 {\n        font-size: 11px !important;\n        margin-bottom: 3px;\n        padding: 0 28px;\n    }\n\n    .class-card p {\n        font-size: var(--font-rm-2) !important;\n    }\n\n    .class-info {\n        padding: 5px 15px;\n        min-height: 75px;\n    }\n\n    .class-image img {\n        width: 38px;\n    }\n\n    .lead-title {\n        font-size: var(--font-xxlarge) !important;\n    }\n\n    .lead-2-title {\n        font-size: var(--font-xxlarge) !important;\n        line-height: 1.2;\n    }\n\n    .lead-detail h6 {\n        font-size: var(--font-11) !important;\n    }\n\n    .lead-detail h2 {\n        font-size: var(--font-xxlarge) !important;\n    }\n\n    .heading-lg {\n        font-size: 17px !important;\n    }\n\n    .faq-question h3 {\n        font-size: var(--font-xlarge) !important;\n    }\n\n    .faq-answer p {\n        font-size: var(--font-medium) !important;\n    }\n}\n\n/*---------- FAQ accordion styles --------*/\n\n.faq-accordion {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 15px;\n}\n\n.faq-item {\n    border: 1px solid var(--btn-color-primary);\n    border-radius: 12px;\n    background-color: var(--color-white);\n    overflow: hidden;\n    transition: all 0.3s ease;\n    box-shadow: none;\n\n}\n\n.deal-message {\n    font-size: 17px;\n    padding: 0 50px;\n}\n\n.deal-message span {\n    font-weight: 500;\n}\n\n.sin-button {\n    font-family: var(--font-inter-medium);\n    color: var(--text-color-white);\n    font-size: 13px;\n}\n\n.faq-item:hover {\n    box-shadow: 0px 4px 12px rgba(15, 132, 176, 0.15);\n}\n\n.faq-item.active {\n    border-color: var(--btn-color-primary);\n    box-shadow: 0px 4px 12px rgba(15, 132, 176, 0.2);\n}\n\n.faq-question {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 18px 20px;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 0.2s ease;\n}\n\n.faq-question:hover {\n    background-color: rgba(15, 132, 176, 0.03);\n}\n\n.faq-question h3 {\n    font-family: var(--font-inter-semi-bold);\n    font-size: var(--font-xxxlarge);\n    color: var(--text-color-primary);\n    margin: 0;\n    padding-right: 15px;\n    line-height: 1.4;\n    flex: 1;\n}\n\n.faq-icon {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    background-color: rgba(15, 132, 176, 0.1);\n    transition: all 0.3s ease;\n}\n\n.faq-icon svg {\n    color: var(--btn-color-primary);\n    transition: transform 0.3s ease;\n}\n\n.faq-icon.rotate svg {\n    transform: rotate(180deg);\n}\n\n.faq-item.active .faq-icon {\n    background-color: var(--btn-color-primary);\n}\n\n.faq-item.active .faq-icon svg {\n    color: var(--text-color-white);\n}\n\n.faq-answer {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.4s ease, padding 0.4s ease;\n    padding: 0 20px;\n}\n\n.faq-answer.show {\n    max-height: 500px;\n    padding: 0 20px 18px 20px;\n}\n\n.faq-answer p {\n    font-size: var(--font-xxlarge);\n    color: var(--color-grey-3);\n    font-family: var(--font-inter-regular);\n    line-height: 1.4;\n    margin-bottom: 5px;\n}\n\n.date-input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.calendar-icon-wrapper {\n    position: absolute;\n    right: 12px;\n    /* Adjust if validation checkmark is present, maybe right: 35px if validated */\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    z-index: 10;\n}\n\n.date-input-container.validated .calendar-icon-wrapper {\n    right: 35px;\n}\n\n.calendar-icon {\n    color: #6B7280;\n    font-size: 16px;\n}\n\n.form-check-input {\n    border-color: gray;\n}\n\n@media (min-width: 768px) and (max-width: 1440px) {\n    .testimonial-card {\n        min-height: 378px;\n    }\n\n    .testimonial-desc {\n        font-size: var(--font-large);\n    }\n\n    .lead-title {\n        font-size: var(--font-xlarge) !important;\n    }\n\n    .badge-reserved-price {\n        font-size: 11px !important;\n    }\n\n    .price-text {\n        font-size: 20px !important;\n    }\n\n    .auction-text {\n        font-size: 11.22px !important;\n    }\n\n    .address-text {\n        font-size: 10.22px;\n    }\n\n    .disclaimer-text {\n        font-size: 8px;\n    }\n\n    .feature-label {\n        font-size: 6px;\n    }\n\n}\n\n.area-value {\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
